/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * WEG
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

export interface Country {
  /** @nullable */
  isocode?: string | null;
}

export interface Region {
  /** @nullable */
  isocode?: string | null;
}

export interface Address {
  country?: Country;
  defaultAddress?: boolean;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  line1?: string | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  postalCode?: string | null;
  region?: Region;
}

export interface ConvertTokenInput {
  /** @nullable */
  jwt?: string | null;
  /** @nullable */
  easyToken?: string | null;
}

export interface Countries {
  /** @nullable */
  label?: string | null;
  /** @nullable */
  value?: string | null;
}

export interface Districts {
  /** @nullable */
  label?: string | null;
  /** @nullable */
  value?: string | null;
}

export interface ValueList {
  /** @nullable */
  type?: string | null;
  /** @nullable */
  value?: string | null;
}

export interface FromToBaseMotorCharacteristics {
  /** @nullable */
  name?: string | null;
  /** @nullable */
  valueList?: ValueList[] | null;
}

export interface FromToCharacteristic {
  /** @nullable */
  name?: string | null;
  /** @nullable */
  valueList?: ValueList[] | null;
}

export interface FromToMotorCharacteristics {
  /** @nullable */
  name?: string | null;
  /** @nullable */
  valueList?: ValueList[] | null;
}

export interface GeoPoint {
  latitude?: number;
  longitude?: number;
}

export interface LanguageCodeClass {
  /** @nullable */
  languageCode: string | null;
}

export interface MailRequest {
  /** @nullable */
  toEmails?: string[] | null;
  /** @nullable */
  subject?: string | null;
  /** @nullable */
  body?: string | null;
  isHtmlBody?: boolean;
  /** @nullable */
  attachments?: Blob[] | null;
}

export interface NeedHelp {
  /** @nullable */
  name?: string | null;
  /** @nullable */
  eMail?: string | null;
  /** @nullable */
  phoneNumber?: string | null;
  /** @nullable */
  company?: string | null;
  /** @nullable */
  country?: string | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  recaptchaToken?: string | null;
  /** @nullable */
  language?: string | null;
}

export interface NotSyncedEasyProductList {
  /** @nullable */
  applicationProductId?: string | null;
  /** @nullable */
  exceptionMessage?: string | null;
}

export interface PointsOfService {
  /** @nullable */
  label?: string | null;
  address?: Address;
  /** @nullable */
  displayName?: string | null;
  geoPoint?: GeoPoint;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  type?: string | null;
}

export interface ProblemDetails {
  /** @nullable */
  type?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  status?: number | null;
  /** @nullable */
  detail?: string | null;
  /** @nullable */
  instance?: string | null;
  [key: string]: unknown;
}

export interface Products {
  /** @nullable */
  label?: string | null;
  /** @nullable */
  value?: string | null;
}

export interface Regions {
  /** @nullable */
  label?: string | null;
  /** @nullable */
  value?: string | null;
}

export interface ReturnedString {
  /** @nullable */
  string?: string | null;
}

export interface SessionExpired {
  isNewSession?: boolean;
}

export interface Towns {
  /** @nullable */
  label?: string | null;
  /** @nullable */
  value?: string | null;
}

export interface VMEasyProductList {
  /** @nullable */
  applicationProductId?: string | null;
  /** @nullable */
  customId?: string | null;
  /** @nullable */
  application?: string | null;
  /** @nullable */
  baseConfigurable?: string | null;
  /** @nullable */
  entryNumber?: string | null;
  /** @nullable */
  exceptionMessage?: string | null;
  /** @nullable */
  fromToCharacteristics?: FromToCharacteristic[] | null;
  /** @nullable */
  fromToMotorCharacteristics?: FromToMotorCharacteristics[] | null;
  /** @nullable */
  fromToBaseMotorCharacteristics?: FromToBaseMotorCharacteristics[] | null;
}

export interface VM3PQToEasySynchronization {
  /** @nullable */
  cartId?: string | null;
  /** @nullable */
  catalog?: string | null;
  /** @nullable */
  hatUser?: string | null;
  /** @nullable */
  origin?: string | null;
  /** @nullable */
  purchaseCountry?: string | null;
  /** @nullable */
  quotationCode?: string | null;
  /** @nullable */
  quotationRevision?: string | null;
  /** @nullable */
  siteLanguage?: string | null;
  /** @nullable */
  sourceSystem?: string | null;
  /** @nullable */
  user?: string | null;
  /** @nullable */
  productList?: VMEasyProductList[] | null;
}

export interface VMAddress {
  /** @nullable */
  street?: string | null;
  /** @nullable */
  streetNr?: string | null;
  /** @nullable */
  zipCode?: string | null;
  /** @nullable */
  city?: string | null;
}

export interface VMAskForQuotationEmail {
  /** @nullable */
  language?: string | null;
  /** @nullable */
  country?: string | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  town?: string | null;
  /** @nullable */
  district?: string | null;
}

export interface VMAskForQuotation {
  /** @nullable */
  eMail?: string | null;
  /** @nullable */
  userName?: string | null;
  /** @nullable */
  companyName?: string | null;
  address?: VMAddress;
  /** @nullable */
  phoneNumber?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  emails?: string[] | null;
  model?: VMAskForQuotationEmail;
  /** @nullable */
  recaptchaToken?: string | null;
  /** @nullable */
  language?: string | null;
}

export interface VMPropertiesEmbeddedPost {
  /** @minLength 1 */
  identifier: string;
  /** @nullable */
  referenceIdentifier?: string | null;
  /** @nullable */
  value?: string | null;
  /** @nullable */
  dataTypeId?: string | null;
}

export interface VMPropertySetsEmbeddedPost {
  /** @minLength 1 */
  identifier: string;
  /** @nullable */
  referenceIdentifier?: string | null;
  /** @nullable */
  properties?: VMPropertiesEmbeddedPost[] | null;
}

export interface VMAttachmentsEmbeddedPost {
  /** @nullable */
  fileAsBytes?: string | null;
  /** @minLength 1 */
  fileName: string;
  /** @nullable */
  typeId?: string | null;
  /** @nullable */
  categoryId?: string | null;
  /** @nullable */
  referenceIdentifier?: string | null;
  propertySet?: VMPropertySetsEmbeddedPost;
}

export interface VMAttachmentSetsEmbeddedPost {
  /** @nullable */
  attachments?: VMAttachmentsEmbeddedPost[] | null;
}

export interface VMDiscountsEmbeddedPost {
  value?: number;
  isPercentage?: boolean;
  /** @nullable */
  discountKindIdentifier?: string | null;
}

export interface VMEasyRedirect {
  /** @nullable */
  url?: string | null;
}

/**
 * @nullable
 */
export type VMEasySynchronizationResponseCpqErrorList = {
  [key: string]: string;
} | null;

export interface VMEasySynchronizationResponse {
  /** @nullable */
  returnUrl?: string | null;
  /** @nullable */
  returnLocation?: string | null;
  /** @nullable */
  syncedItems?: string[] | null;
  /** @nullable */
  cpqErrorList?: VMEasySynchronizationResponseCpqErrorList;
  /** @nullable */
  easyErrorList?: NotSyncedEasyProductList[] | null;
}

export interface VMImportLineItem {
  /** @nullable */
  lineItemIds?: string[] | null;
  /** @nullable */
  projectId?: string | null;
  overrideExisting?: boolean;
}

export interface VMInitiateSessionFromWebsite {
  /** @nullable */
  origin?: string | null;
  /** @nullable */
  purchaseCountry?: string | null;
  /** @nullable */
  catalog?: string | null;
  customer?: number;
  /** @nullable */
  customerName?: string | null;
  /** @nullable */
  language?: string | null;
  /** @nullable */
  productCategory?: string | null;
  /** @nullable */
  intermediateToken?: string | null;
}

export interface VMIsLoggedIn {
  isLoggedIn?: boolean;
}

export interface VMLineItemInformation {
  /** @nullable */
  notes?: string | null;
  /** @nullable */
  customerId?: string | null;
  /** @nullable */
  priceIndicator?: string | null;
  /** @nullable */
  typeCode?: string | null;
}

export interface VMLineItemList {
  /** @nullable */
  lineItems?: string[] | null;
}

export interface VMQuotesPost {
  /** @nullable */
  identifier?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  referenceIdentifier?: string | null;
  /** @nullable */
  isOptional?: boolean | null;
  /** @nullable */
  rank?: number | null;
  /** @nullable */
  customer?: string | null;
  /** @nullable */
  company?: string | null;
  /** @nullable */
  region?: string | null;
  /** @nullable */
  validFrom?: string | null;
  /** @nullable */
  validTo?: string | null;
  propertySet?: VMPropertySetsEmbeddedPost;
  attachmentSet?: VMAttachmentSetsEmbeddedPost;
  /**
   * @deprecated
   * @nullable
   */
  markup?: number | null;
  /**
   * @deprecated
   * @nullable
   */
  markupPercentage?: number | null;
  /**
   * @deprecated
   * @nullable
   */
  serviceMarkup?: number | null;
  /**
   * @deprecated
   * @nullable
   */
  serviceMarkupPercentage?: number | null;
  /**
   * @deprecated
   * @nullable
   */
  discount?: number | null;
  /**
   * @deprecated
   * @nullable
   */
  discountPercentage?: number | null;
  /**
   * @deprecated
   * @nullable
   */
  serviceDiscount?: number | null;
  /**
   * @deprecated
   * @nullable
   */
  serviceDiscountPercentage?: number | null;
  /**
   * @deprecated
   * @nullable
   */
  bonusDiscount?: number | null;
  /**
   * @deprecated
   * @nullable
   */
  bonusDiscountPercentage?: number | null;
  /**
   * @deprecated
   * @nullable
   */
  projectDiscount?: number | null;
  /**
   * @deprecated
   * @nullable
   */
  projectDiscountPercentage?: number | null;
  /** @nullable */
  discounts?: VMDiscountsEmbeddedPost[] | null;
  /** @nullable */
  opportunityId?: string | null;
  /** @nullable */
  statusId?: string | null;
  /** @nullable */
  quoteTypeId?: string | null;
  /** @nullable */
  currencyId?: string | null;
  /** @nullable */
  companyId?: string | null;
  /** @nullable */
  customerId?: string | null;
}

export interface VMWegStoreFinder {
  /** @nullable */
  countries?: Countries[] | null;
  /** @nullable */
  pointsOfService?: PointsOfService[] | null;
  /** @nullable */
  products?: Products[] | null;
  /** @nullable */
  regions?: Regions[] | null;
  /** @nullable */
  towns?: Towns[] | null;
  /** @nullable */
  districts?: Districts[] | null;
}

export interface WegTestCallInput {
  /** @nullable */
  domain?: string | null;
  /** @nullable */
  username?: string | null;
  /** @nullable */
  bearerToken?: string | null;
}

export type GetApiDownloadsDownloadDataSheetParams = {
  materialNumber?: string;
  country?: string;
  language?: string;
};

export type GetApiLineItemApiLineItemPropertiesParams = {
  lineItemId?: string;
};

export type PutApiLineItemApiLineItemPropertiesParams = {
  lineItemId?: string;
};

export type PostApi3pqCpqV1LineitemsCloneIdParams = {
  cloneAttachments?: boolean;
  cloneProperties?: boolean;
  cloneComments?: boolean;
  cloneConfiguration?: boolean;
  cloneDeep?: boolean;
};

export type DeleteApiQuoteApiDeleteEmptyQuotesParams = {
  password?: string;
};

export type GetApi3pqCpqV1StatusIdParams = {
  languageId?: string[];
  start?: number;
  size?: number;
  sort?: string;
  order?: string;
  includes?: string;
  filter?: string;
};

export type GetApiTestSimulateErrorParams = {
  statusCode?: number;
};

const withQueryKey = <T extends object, K>(
  query: T,
  queryKey: K,
): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type postApiAskForQuotationAskForQuotationEmailResponse200TextPlain = {
  data: VMWegStoreFinder;
  status: 200;
};

export type postApiAskForQuotationAskForQuotationEmailResponse200ApplicationJson =
  {
    data: VMWegStoreFinder;
    status: 200;
  };

export type postApiAskForQuotationAskForQuotationEmailResponse200TextJson = {
  data: VMWegStoreFinder;
  status: 200;
};

export type postApiAskForQuotationAskForQuotationEmailResponse500 = {
  data: void;
  status: 500;
};

export type postApiAskForQuotationAskForQuotationEmailResponseSuccess = (
  | postApiAskForQuotationAskForQuotationEmailResponse200TextPlain
  | postApiAskForQuotationAskForQuotationEmailResponse200ApplicationJson
  | postApiAskForQuotationAskForQuotationEmailResponse200TextJson
) & {
  headers: Headers;
};
export type postApiAskForQuotationAskForQuotationEmailResponseError =
  postApiAskForQuotationAskForQuotationEmailResponse500 & {
    headers: Headers;
  };

export const getPostApiAskForQuotationAskForQuotationEmailUrl = () => {
  return `/api/AskForQuotation/AskForQuotationEmail`;
};

export const postApiAskForQuotationAskForQuotationEmail = async (
  vMAskForQuotationEmail?: VMAskForQuotationEmail,
  options?: RequestInit,
): Promise<postApiAskForQuotationAskForQuotationEmailResponseSuccess> => {
  const res = await fetch(getPostApiAskForQuotationAskForQuotationEmailUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(vMAskForQuotationEmail),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & {
      info?: postApiAskForQuotationAskForQuotationEmailResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: postApiAskForQuotationAskForQuotationEmailResponseError["data"] =
      body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: postApiAskForQuotationAskForQuotationEmailResponseSuccess["data"] =
    body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiAskForQuotationAskForQuotationEmailResponseSuccess;
};

export const getPostApiAskForQuotationAskForQuotationEmailMutationOptions = <
  TError = globalThis.Error & { info?: void; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiAskForQuotationAskForQuotationEmail>>,
    TError,
    { data?: VMAskForQuotationEmail },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiAskForQuotationAskForQuotationEmail>>,
  TError,
  { data?: VMAskForQuotationEmail },
  TContext
> => {
  const mutationKey = ["postApiAskForQuotationAskForQuotationEmail"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiAskForQuotationAskForQuotationEmail>>,
    { data?: VMAskForQuotationEmail }
  > = (props) => {
    const { data } = props ?? {};

    return postApiAskForQuotationAskForQuotationEmail(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiAskForQuotationAskForQuotationEmailMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiAskForQuotationAskForQuotationEmail>>
  >;
export type PostApiAskForQuotationAskForQuotationEmailMutationBody =
  VMAskForQuotationEmail | undefined;
export type PostApiAskForQuotationAskForQuotationEmailMutationError =
  globalThis.Error & { info?: void; status?: number };

export const usePostApiAskForQuotationAskForQuotationEmail = <
  TError = globalThis.Error & { info?: void; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiAskForQuotationAskForQuotationEmail>>,
      TError,
      { data?: VMAskForQuotationEmail },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiAskForQuotationAskForQuotationEmail>>,
  TError,
  { data?: VMAskForQuotationEmail },
  TContext
> => {
  return useMutation(
    getPostApiAskForQuotationAskForQuotationEmailMutationOptions(options),
    queryClient,
  );
};

export type postApiAskForQuotationSendAskForQuotationEmailResponse200 = {
  data: void;
  status: 200;
};

export type postApiAskForQuotationSendAskForQuotationEmailResponse400TextPlain =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiAskForQuotationSendAskForQuotationEmailResponse400ApplicationJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiAskForQuotationSendAskForQuotationEmailResponse400TextJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type postApiAskForQuotationSendAskForQuotationEmailResponse401TextPlain =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiAskForQuotationSendAskForQuotationEmailResponse401ApplicationJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiAskForQuotationSendAskForQuotationEmailResponse401TextJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type postApiAskForQuotationSendAskForQuotationEmailResponseSuccess =
  postApiAskForQuotationSendAskForQuotationEmailResponse200 & {
    headers: Headers;
  };
export type postApiAskForQuotationSendAskForQuotationEmailResponseError = (
  | postApiAskForQuotationSendAskForQuotationEmailResponse400TextPlain
  | postApiAskForQuotationSendAskForQuotationEmailResponse400ApplicationJson
  | postApiAskForQuotationSendAskForQuotationEmailResponse400TextJson
  | postApiAskForQuotationSendAskForQuotationEmailResponse401TextPlain
  | postApiAskForQuotationSendAskForQuotationEmailResponse401ApplicationJson
  | postApiAskForQuotationSendAskForQuotationEmailResponse401TextJson
) & {
  headers: Headers;
};

export const getPostApiAskForQuotationSendAskForQuotationEmailUrl = () => {
  return `/api/AskForQuotation/SendAskForQuotationEmail`;
};

export const postApiAskForQuotationSendAskForQuotationEmail = async (
  vMAskForQuotation?: VMAskForQuotation,
  options?: RequestInit,
): Promise<postApiAskForQuotationSendAskForQuotationEmailResponseSuccess> => {
  const res = await fetch(
    getPostApiAskForQuotationSendAskForQuotationEmailUrl(),
    {
      ...options,
      method: "POST",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(vMAskForQuotation),
    },
  );

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: postApiAskForQuotationSendAskForQuotationEmailResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: postApiAskForQuotationSendAskForQuotationEmailResponseError["data"] =
      body ? (errorContentType.includes("json") ? JSON.parse(body) : body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: postApiAskForQuotationSendAskForQuotationEmailResponseSuccess["data"] =
    body ? JSON.parse(body) : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiAskForQuotationSendAskForQuotationEmailResponseSuccess;
};

export const getPostApiAskForQuotationSendAskForQuotationEmailMutationOptions =
  <
    TError = globalThis.Error & { info?: ProblemDetails; status?: number },
    TContext = unknown,
  >(options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiAskForQuotationSendAskForQuotationEmail>
      >,
      TError,
      { data?: VMAskForQuotation },
      TContext
    >;
    fetch?: RequestInit;
  }): UseMutationOptions<
    Awaited<ReturnType<typeof postApiAskForQuotationSendAskForQuotationEmail>>,
    TError,
    { data?: VMAskForQuotation },
    TContext
  > => {
    const mutationKey = ["postApiAskForQuotationSendAskForQuotationEmail"];
    const { mutation: mutationOptions, fetch: fetchOptions } = options
      ? options.mutation &&
        "mutationKey" in options.mutation &&
        options.mutation.mutationKey
        ? options
        : { ...options, mutation: { ...options.mutation, mutationKey } }
      : { mutation: { mutationKey }, fetch: undefined };

    const mutationFn: MutationFunction<
      Awaited<
        ReturnType<typeof postApiAskForQuotationSendAskForQuotationEmail>
      >,
      { data?: VMAskForQuotation }
    > = (props) => {
      const { data } = props ?? {};

      return postApiAskForQuotationSendAskForQuotationEmail(data, fetchOptions);
    };

    return { mutationFn, ...mutationOptions };
  };

export type PostApiAskForQuotationSendAskForQuotationEmailMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof postApiAskForQuotationSendAskForQuotationEmail>>
  >;
export type PostApiAskForQuotationSendAskForQuotationEmailMutationBody =
  VMAskForQuotation | undefined;
export type PostApiAskForQuotationSendAskForQuotationEmailMutationError =
  globalThis.Error & { info?: ProblemDetails; status?: number };

export const usePostApiAskForQuotationSendAskForQuotationEmail = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<
        ReturnType<typeof postApiAskForQuotationSendAskForQuotationEmail>
      >,
      TError,
      { data?: VMAskForQuotation },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiAskForQuotationSendAskForQuotationEmail>>,
  TError,
  { data?: VMAskForQuotation },
  TContext
> => {
  return useMutation(
    getPostApiAskForQuotationSendAskForQuotationEmailMutationOptions(options),
    queryClient,
  );
};

export type getApiDownloadsDownloadDataSheetResponse200 = {
  data: void;
  status: 200;
};

export type getApiDownloadsDownloadDataSheetResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiDownloadsDownloadDataSheetResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiDownloadsDownloadDataSheetResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiDownloadsDownloadDataSheetResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiDownloadsDownloadDataSheetResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiDownloadsDownloadDataSheetResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiDownloadsDownloadDataSheetResponse409TextPlain = {
  data: ProblemDetails;
  status: 409;
};

export type getApiDownloadsDownloadDataSheetResponse409ApplicationJson = {
  data: ProblemDetails;
  status: 409;
};

export type getApiDownloadsDownloadDataSheetResponse409TextJson = {
  data: ProblemDetails;
  status: 409;
};

export type getApiDownloadsDownloadDataSheetResponseSuccess =
  getApiDownloadsDownloadDataSheetResponse200 & {
    headers: Headers;
  };
export type getApiDownloadsDownloadDataSheetResponseError = (
  | getApiDownloadsDownloadDataSheetResponse400TextPlain
  | getApiDownloadsDownloadDataSheetResponse400ApplicationJson
  | getApiDownloadsDownloadDataSheetResponse400TextJson
  | getApiDownloadsDownloadDataSheetResponse401TextPlain
  | getApiDownloadsDownloadDataSheetResponse401ApplicationJson
  | getApiDownloadsDownloadDataSheetResponse401TextJson
  | getApiDownloadsDownloadDataSheetResponse409TextPlain
  | getApiDownloadsDownloadDataSheetResponse409ApplicationJson
  | getApiDownloadsDownloadDataSheetResponse409TextJson
) & {
  headers: Headers;
};

export const getGetApiDownloadsDownloadDataSheetUrl = (
  params?: GetApiDownloadsDownloadDataSheetParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/Downloads/DownloadDataSheet?${stringifiedParams}`
    : `/api/Downloads/DownloadDataSheet`;
};

export const getApiDownloadsDownloadDataSheet = async (
  params?: GetApiDownloadsDownloadDataSheetParams,
  options?: RequestInit,
): Promise<getApiDownloadsDownloadDataSheetResponseSuccess> => {
  const res = await fetch(getGetApiDownloadsDownloadDataSheetUrl(params), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: getApiDownloadsDownloadDataSheetResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: getApiDownloadsDownloadDataSheetResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: getApiDownloadsDownloadDataSheetResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiDownloadsDownloadDataSheetResponseSuccess;
};

export const getGetApiDownloadsDownloadDataSheetQueryKey = (
  params?: GetApiDownloadsDownloadDataSheetParams,
) => {
  return [
    `/api/Downloads/DownloadDataSheet`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiDownloadsDownloadDataSheetQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  params?: GetApiDownloadsDownloadDataSheetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiDownloadsDownloadDataSheetQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>
  > = ({ signal }) =>
    getApiDownloadsDownloadDataSheet(params, { signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiDownloadsDownloadDataSheetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>
>;
export type GetApiDownloadsDownloadDataSheetQueryError = globalThis.Error & {
  info?: ProblemDetails;
  status?: number;
};

export function useGetApiDownloadsDownloadDataSheet<
  TData = Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  params: undefined | GetApiDownloadsDownloadDataSheetParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
          TError,
          Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiDownloadsDownloadDataSheet<
  TData = Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  params?: GetApiDownloadsDownloadDataSheetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
          TError,
          Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiDownloadsDownloadDataSheet<
  TData = Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  params?: GetApiDownloadsDownloadDataSheetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiDownloadsDownloadDataSheet<
  TData = Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  params?: GetApiDownloadsDownloadDataSheetParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiDownloadsDownloadDataSheet>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiDownloadsDownloadDataSheetQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getApiEasyCheckLoginStateResponse200TextPlain = {
  data: ReturnedString;
  status: 200;
};

export type getApiEasyCheckLoginStateResponse200ApplicationJson = {
  data: ReturnedString;
  status: 200;
};

export type getApiEasyCheckLoginStateResponse200TextJson = {
  data: ReturnedString;
  status: 200;
};

export type getApiEasyCheckLoginStateResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiEasyCheckLoginStateResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiEasyCheckLoginStateResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiEasyCheckLoginStateResponseSuccess = (
  | getApiEasyCheckLoginStateResponse200TextPlain
  | getApiEasyCheckLoginStateResponse200ApplicationJson
  | getApiEasyCheckLoginStateResponse200TextJson
) & {
  headers: Headers;
};
export type getApiEasyCheckLoginStateResponseError = (
  | getApiEasyCheckLoginStateResponse401TextPlain
  | getApiEasyCheckLoginStateResponse401ApplicationJson
  | getApiEasyCheckLoginStateResponse401TextJson
) & {
  headers: Headers;
};

export const getGetApiEasyCheckLoginStateUrl = () => {
  return `/api/Easy/CheckLoginState`;
};

export const getApiEasyCheckLoginState = async (
  options?: RequestInit,
): Promise<getApiEasyCheckLoginStateResponseSuccess> => {
  const res = await fetch(getGetApiEasyCheckLoginStateUrl(), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: getApiEasyCheckLoginStateResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: getApiEasyCheckLoginStateResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: getApiEasyCheckLoginStateResponseSuccess["data"] = body
    ? contentType.includes("json")
      ? JSON.parse(body)
      : body
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiEasyCheckLoginStateResponseSuccess;
};

export const getGetApiEasyCheckLoginStateQueryKey = () => {
  return [`/api/Easy/CheckLoginState`] as const;
};

export const getGetApiEasyCheckLoginStateQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiEasyCheckLoginStateQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiEasyCheckLoginState>>
  > = ({ signal }) => getApiEasyCheckLoginState({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiEasyCheckLoginStateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiEasyCheckLoginState>>
>;
export type GetApiEasyCheckLoginStateQueryError = globalThis.Error & {
  info?: ProblemDetails;
  status?: number;
};

export function useGetApiEasyCheckLoginState<
  TData = Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
          TError,
          Awaited<ReturnType<typeof getApiEasyCheckLoginState>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiEasyCheckLoginState<
  TData = Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
          TError,
          Awaited<ReturnType<typeof getApiEasyCheckLoginState>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiEasyCheckLoginState<
  TData = Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiEasyCheckLoginState<
  TData = Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyCheckLoginState>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiEasyCheckLoginStateQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type postApiEasyRedirectToEasyResponse200TextPlain = {
  data: VMEasySynchronizationResponse;
  status: 200;
};

export type postApiEasyRedirectToEasyResponse200ApplicationJson = {
  data: VMEasySynchronizationResponse;
  status: 200;
};

export type postApiEasyRedirectToEasyResponse200TextJson = {
  data: VMEasySynchronizationResponse;
  status: 200;
};

export type postApiEasyRedirectToEasyResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasyRedirectToEasyResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasyRedirectToEasyResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasyRedirectToEasyResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasyRedirectToEasyResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasyRedirectToEasyResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasyRedirectToEasyResponse409TextPlain = {
  data: ProblemDetails;
  status: 409;
};

export type postApiEasyRedirectToEasyResponse409ApplicationJson = {
  data: ProblemDetails;
  status: 409;
};

export type postApiEasyRedirectToEasyResponse409TextJson = {
  data: ProblemDetails;
  status: 409;
};

export type postApiEasyRedirectToEasyResponseSuccess = (
  | postApiEasyRedirectToEasyResponse200TextPlain
  | postApiEasyRedirectToEasyResponse200ApplicationJson
  | postApiEasyRedirectToEasyResponse200TextJson
) & {
  headers: Headers;
};
export type postApiEasyRedirectToEasyResponseError = (
  | postApiEasyRedirectToEasyResponse400TextPlain
  | postApiEasyRedirectToEasyResponse400ApplicationJson
  | postApiEasyRedirectToEasyResponse400TextJson
  | postApiEasyRedirectToEasyResponse401TextPlain
  | postApiEasyRedirectToEasyResponse401ApplicationJson
  | postApiEasyRedirectToEasyResponse401TextJson
  | postApiEasyRedirectToEasyResponse409TextPlain
  | postApiEasyRedirectToEasyResponse409ApplicationJson
  | postApiEasyRedirectToEasyResponse409TextJson
) & {
  headers: Headers;
};

export const getPostApiEasyRedirectToEasyUrl = () => {
  return `/api/Easy/RedirectToEasy`;
};

export const postApiEasyRedirectToEasy = async (
  vMLineItemList?: VMLineItemList,
  options?: RequestInit,
): Promise<postApiEasyRedirectToEasyResponseSuccess> => {
  const res = await fetch(getPostApiEasyRedirectToEasyUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(vMLineItemList),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: postApiEasyRedirectToEasyResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: postApiEasyRedirectToEasyResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: postApiEasyRedirectToEasyResponseSuccess["data"] = body
    ? contentType.includes("json")
      ? JSON.parse(body)
      : body
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiEasyRedirectToEasyResponseSuccess;
};

export const getPostApiEasyRedirectToEasyMutationOptions = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiEasyRedirectToEasy>>,
    TError,
    { data?: VMLineItemList },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiEasyRedirectToEasy>>,
  TError,
  { data?: VMLineItemList },
  TContext
> => {
  const mutationKey = ["postApiEasyRedirectToEasy"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiEasyRedirectToEasy>>,
    { data?: VMLineItemList }
  > = (props) => {
    const { data } = props ?? {};

    return postApiEasyRedirectToEasy(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiEasyRedirectToEasyMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiEasyRedirectToEasy>>
>;
export type PostApiEasyRedirectToEasyMutationBody = VMLineItemList | undefined;
export type PostApiEasyRedirectToEasyMutationError = globalThis.Error & {
  info?: ProblemDetails;
  status?: number;
};

export const usePostApiEasyRedirectToEasy = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiEasyRedirectToEasy>>,
      TError,
      { data?: VMLineItemList },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiEasyRedirectToEasy>>,
  TError,
  { data?: VMLineItemList },
  TContext
> => {
  return useMutation(
    getPostApiEasyRedirectToEasyMutationOptions(options),
    queryClient,
  );
};

export type postApiEasySessionFromEasyResponse200 = {
  data: void;
  status: 200;
};

export type postApiEasySessionFromEasyResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasySessionFromEasyResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasySessionFromEasyResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasySessionFromEasyResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasySessionFromEasyResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasySessionFromEasyResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasySessionFromEasyResponseSuccess =
  postApiEasySessionFromEasyResponse200 & {
    headers: Headers;
  };
export type postApiEasySessionFromEasyResponseError = (
  | postApiEasySessionFromEasyResponse400TextPlain
  | postApiEasySessionFromEasyResponse400ApplicationJson
  | postApiEasySessionFromEasyResponse400TextJson
  | postApiEasySessionFromEasyResponse401TextPlain
  | postApiEasySessionFromEasyResponse401ApplicationJson
  | postApiEasySessionFromEasyResponse401TextJson
) & {
  headers: Headers;
};

export const getPostApiEasySessionFromEasyUrl = () => {
  return `/api/Easy/SessionFromEasy`;
};

export const postApiEasySessionFromEasy = async (
  vM3PQToEasySynchronization?: VM3PQToEasySynchronization,
  options?: RequestInit,
): Promise<postApiEasySessionFromEasyResponseSuccess> => {
  const res = await fetch(getPostApiEasySessionFromEasyUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(vM3PQToEasySynchronization),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: postApiEasySessionFromEasyResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: postApiEasySessionFromEasyResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: postApiEasySessionFromEasyResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiEasySessionFromEasyResponseSuccess;
};

export const getPostApiEasySessionFromEasyMutationOptions = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiEasySessionFromEasy>>,
    TError,
    { data?: VM3PQToEasySynchronization },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiEasySessionFromEasy>>,
  TError,
  { data?: VM3PQToEasySynchronization },
  TContext
> => {
  const mutationKey = ["postApiEasySessionFromEasy"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiEasySessionFromEasy>>,
    { data?: VM3PQToEasySynchronization }
  > = (props) => {
    const { data } = props ?? {};

    return postApiEasySessionFromEasy(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiEasySessionFromEasyMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiEasySessionFromEasy>>
>;
export type PostApiEasySessionFromEasyMutationBody =
  VM3PQToEasySynchronization | undefined;
export type PostApiEasySessionFromEasyMutationError = globalThis.Error & {
  info?: ProblemDetails;
  status?: number;
};

export const usePostApiEasySessionFromEasy = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiEasySessionFromEasy>>,
      TError,
      { data?: VM3PQToEasySynchronization },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiEasySessionFromEasy>>,
  TError,
  { data?: VM3PQToEasySynchronization },
  TContext
> => {
  return useMutation(
    getPostApiEasySessionFromEasyMutationOptions(options),
    queryClient,
  );
};

export type postApiEasySessionFromWegWebsiteResponse200 = {
  data: void;
  status: 200;
};

export type postApiEasySessionFromWegWebsiteResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasySessionFromWegWebsiteResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasySessionFromWegWebsiteResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiEasySessionFromWegWebsiteResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasySessionFromWegWebsiteResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasySessionFromWegWebsiteResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiEasySessionFromWegWebsiteResponseSuccess =
  postApiEasySessionFromWegWebsiteResponse200 & {
    headers: Headers;
  };
export type postApiEasySessionFromWegWebsiteResponseError = (
  | postApiEasySessionFromWegWebsiteResponse400TextPlain
  | postApiEasySessionFromWegWebsiteResponse400ApplicationJson
  | postApiEasySessionFromWegWebsiteResponse400TextJson
  | postApiEasySessionFromWegWebsiteResponse401TextPlain
  | postApiEasySessionFromWegWebsiteResponse401ApplicationJson
  | postApiEasySessionFromWegWebsiteResponse401TextJson
) & {
  headers: Headers;
};

export const getPostApiEasySessionFromWegWebsiteUrl = () => {
  return `/api/Easy/SessionFromWegWebsite`;
};

export const postApiEasySessionFromWegWebsite = async (
  vMInitiateSessionFromWebsite?: VMInitiateSessionFromWebsite,
  options?: RequestInit,
): Promise<postApiEasySessionFromWegWebsiteResponseSuccess> => {
  const res = await fetch(getPostApiEasySessionFromWegWebsiteUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(vMInitiateSessionFromWebsite),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: postApiEasySessionFromWegWebsiteResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: postApiEasySessionFromWegWebsiteResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: postApiEasySessionFromWegWebsiteResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiEasySessionFromWegWebsiteResponseSuccess;
};

export const getPostApiEasySessionFromWegWebsiteMutationOptions = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiEasySessionFromWegWebsite>>,
    TError,
    { data?: VMInitiateSessionFromWebsite },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiEasySessionFromWegWebsite>>,
  TError,
  { data?: VMInitiateSessionFromWebsite },
  TContext
> => {
  const mutationKey = ["postApiEasySessionFromWegWebsite"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiEasySessionFromWegWebsite>>,
    { data?: VMInitiateSessionFromWebsite }
  > = (props) => {
    const { data } = props ?? {};

    return postApiEasySessionFromWegWebsite(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiEasySessionFromWegWebsiteMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiEasySessionFromWegWebsite>>
>;
export type PostApiEasySessionFromWegWebsiteMutationBody =
  VMInitiateSessionFromWebsite | undefined;
export type PostApiEasySessionFromWegWebsiteMutationError = globalThis.Error & {
  info?: ProblemDetails;
  status?: number;
};

export const usePostApiEasySessionFromWegWebsite = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiEasySessionFromWegWebsite>>,
      TError,
      { data?: VMInitiateSessionFromWebsite },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiEasySessionFromWegWebsite>>,
  TError,
  { data?: VMInitiateSessionFromWebsite },
  TContext
> => {
  return useMutation(
    getPostApiEasySessionFromWegWebsiteMutationOptions(options),
    queryClient,
  );
};

export type getApiEasyAdministrationAreaResponse200TextPlain = {
  data: ReturnedString;
  status: 200;
};

export type getApiEasyAdministrationAreaResponse200ApplicationJson = {
  data: ReturnedString;
  status: 200;
};

export type getApiEasyAdministrationAreaResponse200TextJson = {
  data: ReturnedString;
  status: 200;
};

export type getApiEasyAdministrationAreaResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiEasyAdministrationAreaResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiEasyAdministrationAreaResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiEasyAdministrationAreaResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiEasyAdministrationAreaResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiEasyAdministrationAreaResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiEasyAdministrationAreaResponseSuccess = (
  | getApiEasyAdministrationAreaResponse200TextPlain
  | getApiEasyAdministrationAreaResponse200ApplicationJson
  | getApiEasyAdministrationAreaResponse200TextJson
) & {
  headers: Headers;
};
export type getApiEasyAdministrationAreaResponseError = (
  | getApiEasyAdministrationAreaResponse400TextPlain
  | getApiEasyAdministrationAreaResponse400ApplicationJson
  | getApiEasyAdministrationAreaResponse400TextJson
  | getApiEasyAdministrationAreaResponse401TextPlain
  | getApiEasyAdministrationAreaResponse401ApplicationJson
  | getApiEasyAdministrationAreaResponse401TextJson
) & {
  headers: Headers;
};

export const getGetApiEasyAdministrationAreaUrl = () => {
  return `/api/Easy/AdministrationArea`;
};

export const getApiEasyAdministrationArea = async (
  options?: RequestInit,
): Promise<getApiEasyAdministrationAreaResponseSuccess> => {
  const res = await fetch(getGetApiEasyAdministrationAreaUrl(), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: getApiEasyAdministrationAreaResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: getApiEasyAdministrationAreaResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: getApiEasyAdministrationAreaResponseSuccess["data"] = body
    ? contentType.includes("json")
      ? JSON.parse(body)
      : body
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiEasyAdministrationAreaResponseSuccess;
};

export const getGetApiEasyAdministrationAreaQueryKey = () => {
  return [`/api/Easy/AdministrationArea`] as const;
};

export const getGetApiEasyAdministrationAreaQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiEasyAdministrationAreaQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiEasyAdministrationArea>>
  > = ({ signal }) => getApiEasyAdministrationArea({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiEasyAdministrationAreaQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiEasyAdministrationArea>>
>;
export type GetApiEasyAdministrationAreaQueryError = globalThis.Error & {
  info?: ProblemDetails;
  status?: number;
};

export function useGetApiEasyAdministrationArea<
  TData = Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
          TError,
          Awaited<ReturnType<typeof getApiEasyAdministrationArea>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiEasyAdministrationArea<
  TData = Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
          TError,
          Awaited<ReturnType<typeof getApiEasyAdministrationArea>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiEasyAdministrationArea<
  TData = Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiEasyAdministrationArea<
  TData = Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyAdministrationArea>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiEasyAdministrationAreaQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type putApiEasyAdministrationAreaResponse200TextPlain = {
  data: ReturnedString;
  status: 200;
};

export type putApiEasyAdministrationAreaResponse200ApplicationJson = {
  data: ReturnedString;
  status: 200;
};

export type putApiEasyAdministrationAreaResponse200TextJson = {
  data: ReturnedString;
  status: 200;
};

export type putApiEasyAdministrationAreaResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type putApiEasyAdministrationAreaResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type putApiEasyAdministrationAreaResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type putApiEasyAdministrationAreaResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type putApiEasyAdministrationAreaResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type putApiEasyAdministrationAreaResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type putApiEasyAdministrationAreaResponseSuccess = (
  | putApiEasyAdministrationAreaResponse200TextPlain
  | putApiEasyAdministrationAreaResponse200ApplicationJson
  | putApiEasyAdministrationAreaResponse200TextJson
) & {
  headers: Headers;
};
export type putApiEasyAdministrationAreaResponseError = (
  | putApiEasyAdministrationAreaResponse400TextPlain
  | putApiEasyAdministrationAreaResponse400ApplicationJson
  | putApiEasyAdministrationAreaResponse400TextJson
  | putApiEasyAdministrationAreaResponse401TextPlain
  | putApiEasyAdministrationAreaResponse401ApplicationJson
  | putApiEasyAdministrationAreaResponse401TextJson
) & {
  headers: Headers;
};

export const getPutApiEasyAdministrationAreaUrl = () => {
  return `/api/Easy/AdministrationArea`;
};

export const putApiEasyAdministrationArea = async (
  returnedString?: ReturnedString,
  options?: RequestInit,
): Promise<putApiEasyAdministrationAreaResponseSuccess> => {
  const res = await fetch(getPutApiEasyAdministrationAreaUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(returnedString),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: putApiEasyAdministrationAreaResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: putApiEasyAdministrationAreaResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: putApiEasyAdministrationAreaResponseSuccess["data"] = body
    ? contentType.includes("json")
      ? JSON.parse(body)
      : body
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as putApiEasyAdministrationAreaResponseSuccess;
};

export const getPutApiEasyAdministrationAreaMutationOptions = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiEasyAdministrationArea>>,
    TError,
    { data?: ReturnedString },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiEasyAdministrationArea>>,
  TError,
  { data?: ReturnedString },
  TContext
> => {
  const mutationKey = ["putApiEasyAdministrationArea"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiEasyAdministrationArea>>,
    { data?: ReturnedString }
  > = (props) => {
    const { data } = props ?? {};

    return putApiEasyAdministrationArea(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiEasyAdministrationAreaMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiEasyAdministrationArea>>
>;
export type PutApiEasyAdministrationAreaMutationBody =
  ReturnedString | undefined;
export type PutApiEasyAdministrationAreaMutationError = globalThis.Error & {
  info?: ProblemDetails;
  status?: number;
};

export const usePutApiEasyAdministrationArea = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiEasyAdministrationArea>>,
      TError,
      { data?: ReturnedString },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiEasyAdministrationArea>>,
  TError,
  { data?: ReturnedString },
  TContext
> => {
  return useMutation(
    getPutApiEasyAdministrationAreaMutationOptions(options),
    queryClient,
  );
};

export type getApiEasyAdministrationAreaCountryListResponse200TextPlain = {
  data: VMWegStoreFinder;
  status: 200;
};

export type getApiEasyAdministrationAreaCountryListResponse200ApplicationJson =
  {
    data: VMWegStoreFinder;
    status: 200;
  };

export type getApiEasyAdministrationAreaCountryListResponse200TextJson = {
  data: VMWegStoreFinder;
  status: 200;
};

export type getApiEasyAdministrationAreaCountryListResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiEasyAdministrationAreaCountryListResponse400ApplicationJson =
  {
    data: ProblemDetails;
    status: 400;
  };

export type getApiEasyAdministrationAreaCountryListResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiEasyAdministrationAreaCountryListResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiEasyAdministrationAreaCountryListResponse401ApplicationJson =
  {
    data: ProblemDetails;
    status: 401;
  };

export type getApiEasyAdministrationAreaCountryListResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiEasyAdministrationAreaCountryListResponseSuccess = (
  | getApiEasyAdministrationAreaCountryListResponse200TextPlain
  | getApiEasyAdministrationAreaCountryListResponse200ApplicationJson
  | getApiEasyAdministrationAreaCountryListResponse200TextJson
) & {
  headers: Headers;
};
export type getApiEasyAdministrationAreaCountryListResponseError = (
  | getApiEasyAdministrationAreaCountryListResponse400TextPlain
  | getApiEasyAdministrationAreaCountryListResponse400ApplicationJson
  | getApiEasyAdministrationAreaCountryListResponse400TextJson
  | getApiEasyAdministrationAreaCountryListResponse401TextPlain
  | getApiEasyAdministrationAreaCountryListResponse401ApplicationJson
  | getApiEasyAdministrationAreaCountryListResponse401TextJson
) & {
  headers: Headers;
};

export const getGetApiEasyAdministrationAreaCountryListUrl = () => {
  return `/api/Easy/AdministrationAreaCountryList`;
};

export const getApiEasyAdministrationAreaCountryList = async (
  options?: RequestInit,
): Promise<getApiEasyAdministrationAreaCountryListResponseSuccess> => {
  const res = await fetch(getGetApiEasyAdministrationAreaCountryListUrl(), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: getApiEasyAdministrationAreaCountryListResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: getApiEasyAdministrationAreaCountryListResponseError["data"] =
      body ? (errorContentType.includes("json") ? JSON.parse(body) : body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: getApiEasyAdministrationAreaCountryListResponseSuccess["data"] =
    body ? (contentType.includes("json") ? JSON.parse(body) : body) : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiEasyAdministrationAreaCountryListResponseSuccess;
};

export const getGetApiEasyAdministrationAreaCountryListQueryKey = () => {
  return [`/api/Easy/AdministrationAreaCountryList`] as const;
};

export const getGetApiEasyAdministrationAreaCountryListQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiEasyAdministrationAreaCountryListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>
  > = ({ signal }) =>
    getApiEasyAdministrationAreaCountryList({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiEasyAdministrationAreaCountryListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>
>;
export type GetApiEasyAdministrationAreaCountryListQueryError =
  globalThis.Error & { info?: ProblemDetails; status?: number };

export function useGetApiEasyAdministrationAreaCountryList<
  TData = Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
          TError,
          Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiEasyAdministrationAreaCountryList<
  TData = Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
          TError,
          Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiEasyAdministrationAreaCountryList<
  TData = Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiEasyAdministrationAreaCountryList<
  TData = Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyAdministrationAreaCountryList>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions =
    getGetApiEasyAdministrationAreaCountryListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getApiEasyCountryResponse200TextPlain = {
  data: ReturnedString;
  status: 200;
};

export type getApiEasyCountryResponse200ApplicationJson = {
  data: ReturnedString;
  status: 200;
};

export type getApiEasyCountryResponse200TextJson = {
  data: ReturnedString;
  status: 200;
};

export type getApiEasyCountryResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiEasyCountryResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiEasyCountryResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiEasyCountryResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiEasyCountryResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiEasyCountryResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiEasyCountryResponseSuccess = (
  | getApiEasyCountryResponse200TextPlain
  | getApiEasyCountryResponse200ApplicationJson
  | getApiEasyCountryResponse200TextJson
) & {
  headers: Headers;
};
export type getApiEasyCountryResponseError = (
  | getApiEasyCountryResponse400TextPlain
  | getApiEasyCountryResponse400ApplicationJson
  | getApiEasyCountryResponse400TextJson
  | getApiEasyCountryResponse401TextPlain
  | getApiEasyCountryResponse401ApplicationJson
  | getApiEasyCountryResponse401TextJson
) & {
  headers: Headers;
};

export const getGetApiEasyCountryUrl = () => {
  return `/api/Easy/Country`;
};

export const getApiEasyCountry = async (
  options?: RequestInit,
): Promise<getApiEasyCountryResponseSuccess> => {
  const res = await fetch(getGetApiEasyCountryUrl(), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: getApiEasyCountryResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: getApiEasyCountryResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: getApiEasyCountryResponseSuccess["data"] = body
    ? contentType.includes("json")
      ? JSON.parse(body)
      : body
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiEasyCountryResponseSuccess;
};

export const getGetApiEasyCountryQueryKey = () => {
  return [`/api/Easy/Country`] as const;
};

export const getGetApiEasyCountryQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiEasyCountry>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiEasyCountry>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiEasyCountryQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiEasyCountry>>
  > = ({ signal }) => getApiEasyCountry({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiEasyCountry>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiEasyCountryQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiEasyCountry>>
>;
export type GetApiEasyCountryQueryError = globalThis.Error & {
  info?: ProblemDetails;
  status?: number;
};

export function useGetApiEasyCountry<
  TData = Awaited<ReturnType<typeof getApiEasyCountry>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyCountry>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiEasyCountry>>,
          TError,
          Awaited<ReturnType<typeof getApiEasyCountry>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiEasyCountry<
  TData = Awaited<ReturnType<typeof getApiEasyCountry>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyCountry>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiEasyCountry>>,
          TError,
          Awaited<ReturnType<typeof getApiEasyCountry>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiEasyCountry<
  TData = Awaited<ReturnType<typeof getApiEasyCountry>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyCountry>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiEasyCountry<
  TData = Awaited<ReturnType<typeof getApiEasyCountry>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiEasyCountry>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiEasyCountryQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type postApiHealthKeepaliveResponse200TextPlain = {
  data: SessionExpired;
  status: 200;
};

export type postApiHealthKeepaliveResponse200ApplicationJson = {
  data: SessionExpired;
  status: 200;
};

export type postApiHealthKeepaliveResponse200TextJson = {
  data: SessionExpired;
  status: 200;
};

export type postApiHealthKeepaliveResponseSuccess = (
  | postApiHealthKeepaliveResponse200TextPlain
  | postApiHealthKeepaliveResponse200ApplicationJson
  | postApiHealthKeepaliveResponse200TextJson
) & {
  headers: Headers;
};
export const getPostApiHealthKeepaliveUrl = () => {
  return `/api/Health/keepalive`;
};

export const postApiHealthKeepalive = async (
  vMIsLoggedIn?: VMIsLoggedIn,
  options?: RequestInit,
): Promise<postApiHealthKeepaliveResponseSuccess> => {
  const res = await fetch(getPostApiHealthKeepaliveUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(vMIsLoggedIn),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } =
      new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: postApiHealthKeepaliveResponseSuccess["data"] = body
    ? contentType.includes("json")
      ? JSON.parse(body)
      : body
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiHealthKeepaliveResponseSuccess;
};

export const getPostApiHealthKeepaliveMutationOptions = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiHealthKeepalive>>,
    TError,
    { data?: VMIsLoggedIn },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiHealthKeepalive>>,
  TError,
  { data?: VMIsLoggedIn },
  TContext
> => {
  const mutationKey = ["postApiHealthKeepalive"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiHealthKeepalive>>,
    { data?: VMIsLoggedIn }
  > = (props) => {
    const { data } = props ?? {};

    return postApiHealthKeepalive(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiHealthKeepaliveMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiHealthKeepalive>>
>;
export type PostApiHealthKeepaliveMutationBody = VMIsLoggedIn | undefined;
export type PostApiHealthKeepaliveMutationError = globalThis.Error & {
  info?: unknown;
  status?: number;
};

export const usePostApiHealthKeepalive = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiHealthKeepalive>>,
      TError,
      { data?: VMIsLoggedIn },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiHealthKeepalive>>,
  TError,
  { data?: VMIsLoggedIn },
  TContext
> => {
  return useMutation(
    getPostApiHealthKeepaliveMutationOptions(options),
    queryClient,
  );
};

export type postApiImportImportLineitemResponse200TextPlain = {
  data: ReturnedString;
  status: 200;
};

export type postApiImportImportLineitemResponse200ApplicationJson = {
  data: ReturnedString;
  status: 200;
};

export type postApiImportImportLineitemResponse200TextJson = {
  data: ReturnedString;
  status: 200;
};

export type postApiImportImportLineitemResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiImportImportLineitemResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiImportImportLineitemResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiImportImportLineitemResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiImportImportLineitemResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiImportImportLineitemResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiImportImportLineitemResponseSuccess = (
  | postApiImportImportLineitemResponse200TextPlain
  | postApiImportImportLineitemResponse200ApplicationJson
  | postApiImportImportLineitemResponse200TextJson
) & {
  headers: Headers;
};
export type postApiImportImportLineitemResponseError = (
  | postApiImportImportLineitemResponse400TextPlain
  | postApiImportImportLineitemResponse400ApplicationJson
  | postApiImportImportLineitemResponse400TextJson
  | postApiImportImportLineitemResponse401TextPlain
  | postApiImportImportLineitemResponse401ApplicationJson
  | postApiImportImportLineitemResponse401TextJson
) & {
  headers: Headers;
};

export const getPostApiImportImportLineitemUrl = () => {
  return `/api/Import/ImportLineitem`;
};

export const postApiImportImportLineitem = async (
  vMImportLineItem?: VMImportLineItem,
  options?: RequestInit,
): Promise<postApiImportImportLineitemResponseSuccess> => {
  const res = await fetch(getPostApiImportImportLineitemUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(vMImportLineItem),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: postApiImportImportLineitemResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: postApiImportImportLineitemResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: postApiImportImportLineitemResponseSuccess["data"] = body
    ? contentType.includes("json")
      ? JSON.parse(body)
      : body
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiImportImportLineitemResponseSuccess;
};

export const getPostApiImportImportLineitemMutationOptions = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiImportImportLineitem>>,
    TError,
    { data?: VMImportLineItem },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiImportImportLineitem>>,
  TError,
  { data?: VMImportLineItem },
  TContext
> => {
  const mutationKey = ["postApiImportImportLineitem"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiImportImportLineitem>>,
    { data?: VMImportLineItem }
  > = (props) => {
    const { data } = props ?? {};

    return postApiImportImportLineitem(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiImportImportLineitemMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiImportImportLineitem>>
>;
export type PostApiImportImportLineitemMutationBody =
  VMImportLineItem | undefined;
export type PostApiImportImportLineitemMutationError = globalThis.Error & {
  info?: ProblemDetails;
  status?: number;
};

export const usePostApiImportImportLineitem = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiImportImportLineitem>>,
      TError,
      { data?: VMImportLineItem },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiImportImportLineitem>>,
  TError,
  { data?: VMImportLineItem },
  TContext
> => {
  return useMutation(
    getPostApiImportImportLineitemMutationOptions(options),
    queryClient,
  );
};

export type getApiLineItemApiLineItemPropertiesResponse200TextPlain = {
  data: VMLineItemInformation;
  status: 200;
};

export type getApiLineItemApiLineItemPropertiesResponse200ApplicationJson = {
  data: VMLineItemInformation;
  status: 200;
};

export type getApiLineItemApiLineItemPropertiesResponse200TextJson = {
  data: VMLineItemInformation;
  status: 200;
};

export type getApiLineItemApiLineItemPropertiesResponseSuccess = (
  | getApiLineItemApiLineItemPropertiesResponse200TextPlain
  | getApiLineItemApiLineItemPropertiesResponse200ApplicationJson
  | getApiLineItemApiLineItemPropertiesResponse200TextJson
) & {
  headers: Headers;
};
export const getGetApiLineItemApiLineItemPropertiesUrl = (
  params?: GetApiLineItemApiLineItemPropertiesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/LineItemApi/LineItemProperties?${stringifiedParams}`
    : `/api/LineItemApi/LineItemProperties`;
};

export const getApiLineItemApiLineItemProperties = async (
  params?: GetApiLineItemApiLineItemPropertiesParams,
  options?: RequestInit,
): Promise<getApiLineItemApiLineItemPropertiesResponseSuccess> => {
  const res = await fetch(getGetApiLineItemApiLineItemPropertiesUrl(params), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } =
      new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: getApiLineItemApiLineItemPropertiesResponseSuccess["data"] = body
    ? contentType.includes("json")
      ? JSON.parse(body)
      : body
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiLineItemApiLineItemPropertiesResponseSuccess;
};

export const getGetApiLineItemApiLineItemPropertiesQueryKey = (
  params?: GetApiLineItemApiLineItemPropertiesParams,
) => {
  return [
    `/api/LineItemApi/LineItemProperties`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetApiLineItemApiLineItemPropertiesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params?: GetApiLineItemApiLineItemPropertiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiLineItemApiLineItemPropertiesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>
  > = ({ signal }) =>
    getApiLineItemApiLineItemProperties(params, { signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiLineItemApiLineItemPropertiesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>
>;
export type GetApiLineItemApiLineItemPropertiesQueryError = globalThis.Error & {
  info?: unknown;
  status?: number;
};

export function useGetApiLineItemApiLineItemProperties<
  TData = Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params: undefined | GetApiLineItemApiLineItemPropertiesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
          TError,
          Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLineItemApiLineItemProperties<
  TData = Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params?: GetApiLineItemApiLineItemPropertiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
          TError,
          Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiLineItemApiLineItemProperties<
  TData = Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params?: GetApiLineItemApiLineItemPropertiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiLineItemApiLineItemProperties<
  TData = Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  params?: GetApiLineItemApiLineItemPropertiesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiLineItemApiLineItemProperties>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiLineItemApiLineItemPropertiesQueryOptions(
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type putApiLineItemApiLineItemPropertiesResponse200TextPlain = {
  data: VMLineItemInformation;
  status: 200;
};

export type putApiLineItemApiLineItemPropertiesResponse200ApplicationJson = {
  data: VMLineItemInformation;
  status: 200;
};

export type putApiLineItemApiLineItemPropertiesResponse200TextJson = {
  data: VMLineItemInformation;
  status: 200;
};

export type putApiLineItemApiLineItemPropertiesResponseSuccess = (
  | putApiLineItemApiLineItemPropertiesResponse200TextPlain
  | putApiLineItemApiLineItemPropertiesResponse200ApplicationJson
  | putApiLineItemApiLineItemPropertiesResponse200TextJson
) & {
  headers: Headers;
};
export const getPutApiLineItemApiLineItemPropertiesUrl = (
  params?: PutApiLineItemApiLineItemPropertiesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/LineItemApi/LineItemProperties?${stringifiedParams}`
    : `/api/LineItemApi/LineItemProperties`;
};

export const putApiLineItemApiLineItemProperties = async (
  vMLineItemInformation?: VMLineItemInformation,
  params?: PutApiLineItemApiLineItemPropertiesParams,
  options?: RequestInit,
): Promise<putApiLineItemApiLineItemPropertiesResponseSuccess> => {
  const res = await fetch(getPutApiLineItemApiLineItemPropertiesUrl(params), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(vMLineItemInformation),
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } =
      new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: putApiLineItemApiLineItemPropertiesResponseSuccess["data"] = body
    ? contentType.includes("json")
      ? JSON.parse(body)
      : body
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as putApiLineItemApiLineItemPropertiesResponseSuccess;
};

export const getPutApiLineItemApiLineItemPropertiesMutationOptions = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiLineItemApiLineItemProperties>>,
    TError,
    {
      data?: VMLineItemInformation;
      params?: PutApiLineItemApiLineItemPropertiesParams;
    },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiLineItemApiLineItemProperties>>,
  TError,
  {
    data?: VMLineItemInformation;
    params?: PutApiLineItemApiLineItemPropertiesParams;
  },
  TContext
> => {
  const mutationKey = ["putApiLineItemApiLineItemProperties"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiLineItemApiLineItemProperties>>,
    {
      data?: VMLineItemInformation;
      params?: PutApiLineItemApiLineItemPropertiesParams;
    }
  > = (props) => {
    const { data, params } = props ?? {};

    return putApiLineItemApiLineItemProperties(data, params, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiLineItemApiLineItemPropertiesMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiLineItemApiLineItemProperties>>
>;
export type PutApiLineItemApiLineItemPropertiesMutationBody =
  VMLineItemInformation | undefined;
export type PutApiLineItemApiLineItemPropertiesMutationError =
  globalThis.Error & { info?: unknown; status?: number };

export const usePutApiLineItemApiLineItemProperties = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiLineItemApiLineItemProperties>>,
      TError,
      {
        data?: VMLineItemInformation;
        params?: PutApiLineItemApiLineItemPropertiesParams;
      },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiLineItemApiLineItemProperties>>,
  TError,
  {
    data?: VMLineItemInformation;
    params?: PutApiLineItemApiLineItemPropertiesParams;
  },
  TContext
> => {
  return useMutation(
    getPutApiLineItemApiLineItemPropertiesMutationOptions(options),
    queryClient,
  );
};

export type postApi3pqCpqV1LineitemsCloneIdResponse200 = {
  data: void;
  status: 200;
};

export type postApi3pqCpqV1LineitemsCloneIdResponseSuccess =
  postApi3pqCpqV1LineitemsCloneIdResponse200 & {
    headers: Headers;
  };
export const getPostApi3pqCpqV1LineitemsCloneIdUrl = (
  id: string,
  params?: PostApi3pqCpqV1LineitemsCloneIdParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/3pq-cpq/v1/lineitems/clone/${id}?${stringifiedParams}`
    : `/api/3pq-cpq/v1/lineitems/clone/${id}`;
};

export const postApi3pqCpqV1LineitemsCloneId = async (
  id: string,
  params?: PostApi3pqCpqV1LineitemsCloneIdParams,
  options?: RequestInit,
): Promise<postApi3pqCpqV1LineitemsCloneIdResponseSuccess> => {
  const res = await fetch(getPostApi3pqCpqV1LineitemsCloneIdUrl(id, params), {
    ...options,
    method: "POST",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } =
      new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: postApi3pqCpqV1LineitemsCloneIdResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApi3pqCpqV1LineitemsCloneIdResponseSuccess;
};

export const getPostApi3pqCpqV1LineitemsCloneIdMutationOptions = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApi3pqCpqV1LineitemsCloneId>>,
    TError,
    { id: string; params?: PostApi3pqCpqV1LineitemsCloneIdParams },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApi3pqCpqV1LineitemsCloneId>>,
  TError,
  { id: string; params?: PostApi3pqCpqV1LineitemsCloneIdParams },
  TContext
> => {
  const mutationKey = ["postApi3pqCpqV1LineitemsCloneId"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApi3pqCpqV1LineitemsCloneId>>,
    { id: string; params?: PostApi3pqCpqV1LineitemsCloneIdParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return postApi3pqCpqV1LineitemsCloneId(id, params, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApi3pqCpqV1LineitemsCloneIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApi3pqCpqV1LineitemsCloneId>>
>;

export type PostApi3pqCpqV1LineitemsCloneIdMutationError = globalThis.Error & {
  info?: unknown;
  status?: number;
};

export const usePostApi3pqCpqV1LineitemsCloneId = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApi3pqCpqV1LineitemsCloneId>>,
      TError,
      { id: string; params?: PostApi3pqCpqV1LineitemsCloneIdParams },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApi3pqCpqV1LineitemsCloneId>>,
  TError,
  { id: string; params?: PostApi3pqCpqV1LineitemsCloneIdParams },
  TContext
> => {
  return useMutation(
    getPostApi3pqCpqV1LineitemsCloneIdMutationOptions(options),
    queryClient,
  );
};

export type deleteApi3pqCpqV1LineitemsIdResponse200 = {
  data: void;
  status: 200;
};

export type deleteApi3pqCpqV1LineitemsIdResponseSuccess =
  deleteApi3pqCpqV1LineitemsIdResponse200 & {
    headers: Headers;
  };
export const getDeleteApi3pqCpqV1LineitemsIdUrl = (id: string) => {
  return `/api/3pq-cpq/v1/lineitems/${id}`;
};

export const deleteApi3pqCpqV1LineitemsId = async (
  id: string,
  options?: RequestInit,
): Promise<deleteApi3pqCpqV1LineitemsIdResponseSuccess> => {
  const res = await fetch(getDeleteApi3pqCpqV1LineitemsIdUrl(id), {
    ...options,
    method: "DELETE",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } =
      new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: deleteApi3pqCpqV1LineitemsIdResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as deleteApi3pqCpqV1LineitemsIdResponseSuccess;
};

export const getDeleteApi3pqCpqV1LineitemsIdMutationOptions = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApi3pqCpqV1LineitemsId>>,
    TError,
    { id: string },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApi3pqCpqV1LineitemsId>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["deleteApi3pqCpqV1LineitemsId"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApi3pqCpqV1LineitemsId>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return deleteApi3pqCpqV1LineitemsId(id, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApi3pqCpqV1LineitemsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApi3pqCpqV1LineitemsId>>
>;

export type DeleteApi3pqCpqV1LineitemsIdMutationError = globalThis.Error & {
  info?: unknown;
  status?: number;
};

export const useDeleteApi3pqCpqV1LineitemsId = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApi3pqCpqV1LineitemsId>>,
      TError,
      { id: string },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApi3pqCpqV1LineitemsId>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(
    getDeleteApi3pqCpqV1LineitemsIdMutationOptions(options),
    queryClient,
  );
};

export type postApiNeedHelpNeedHelpResponse200 = {
  data: void;
  status: 200;
};

export type postApiNeedHelpNeedHelpResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiNeedHelpNeedHelpResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiNeedHelpNeedHelpResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiNeedHelpNeedHelpResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiNeedHelpNeedHelpResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiNeedHelpNeedHelpResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiNeedHelpNeedHelpResponseSuccess =
  postApiNeedHelpNeedHelpResponse200 & {
    headers: Headers;
  };
export type postApiNeedHelpNeedHelpResponseError = (
  | postApiNeedHelpNeedHelpResponse400TextPlain
  | postApiNeedHelpNeedHelpResponse400ApplicationJson
  | postApiNeedHelpNeedHelpResponse400TextJson
  | postApiNeedHelpNeedHelpResponse401TextPlain
  | postApiNeedHelpNeedHelpResponse401ApplicationJson
  | postApiNeedHelpNeedHelpResponse401TextJson
) & {
  headers: Headers;
};

export const getPostApiNeedHelpNeedHelpUrl = () => {
  return `/api/NeedHelp/NeedHelp`;
};

export const postApiNeedHelpNeedHelp = async (
  needHelp?: NeedHelp,
  options?: RequestInit,
): Promise<postApiNeedHelpNeedHelpResponseSuccess> => {
  const res = await fetch(getPostApiNeedHelpNeedHelpUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(needHelp),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: postApiNeedHelpNeedHelpResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: postApiNeedHelpNeedHelpResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: postApiNeedHelpNeedHelpResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiNeedHelpNeedHelpResponseSuccess;
};

export const getPostApiNeedHelpNeedHelpMutationOptions = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiNeedHelpNeedHelp>>,
    TError,
    { data?: NeedHelp },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiNeedHelpNeedHelp>>,
  TError,
  { data?: NeedHelp },
  TContext
> => {
  const mutationKey = ["postApiNeedHelpNeedHelp"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiNeedHelpNeedHelp>>,
    { data?: NeedHelp }
  > = (props) => {
    const { data } = props ?? {};

    return postApiNeedHelpNeedHelp(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiNeedHelpNeedHelpMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiNeedHelpNeedHelp>>
>;
export type PostApiNeedHelpNeedHelpMutationBody = NeedHelp | undefined;
export type PostApiNeedHelpNeedHelpMutationError = globalThis.Error & {
  info?: ProblemDetails;
  status?: number;
};

export const usePostApiNeedHelpNeedHelp = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiNeedHelpNeedHelp>>,
      TError,
      { data?: NeedHelp },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiNeedHelpNeedHelp>>,
  TError,
  { data?: NeedHelp },
  TContext
> => {
  return useMutation(
    getPostApiNeedHelpNeedHelpMutationOptions(options),
    queryClient,
  );
};

export type postApi3pqCpqV1QuotesResponse200 = {
  data: void;
  status: 200;
};

export type postApi3pqCpqV1QuotesResponseSuccess =
  postApi3pqCpqV1QuotesResponse200 & {
    headers: Headers;
  };
export const getPostApi3pqCpqV1QuotesUrl = () => {
  return `/api/3pq-cpq/v1/quotes`;
};

export const postApi3pqCpqV1Quotes = async (
  vMQuotesPost?: VMQuotesPost,
  options?: RequestInit,
): Promise<postApi3pqCpqV1QuotesResponseSuccess> => {
  const res = await fetch(getPostApi3pqCpqV1QuotesUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(vMQuotesPost),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } =
      new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: postApi3pqCpqV1QuotesResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApi3pqCpqV1QuotesResponseSuccess;
};

export const getPostApi3pqCpqV1QuotesMutationOptions = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApi3pqCpqV1Quotes>>,
    TError,
    { data?: VMQuotesPost },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApi3pqCpqV1Quotes>>,
  TError,
  { data?: VMQuotesPost },
  TContext
> => {
  const mutationKey = ["postApi3pqCpqV1Quotes"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApi3pqCpqV1Quotes>>,
    { data?: VMQuotesPost }
  > = (props) => {
    const { data } = props ?? {};

    return postApi3pqCpqV1Quotes(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApi3pqCpqV1QuotesMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApi3pqCpqV1Quotes>>
>;
export type PostApi3pqCpqV1QuotesMutationBody = VMQuotesPost | undefined;
export type PostApi3pqCpqV1QuotesMutationError = globalThis.Error & {
  info?: unknown;
  status?: number;
};

export const usePostApi3pqCpqV1Quotes = <
  TError = globalThis.Error & { info?: unknown; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApi3pqCpqV1Quotes>>,
      TError,
      { data?: VMQuotesPost },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApi3pqCpqV1Quotes>>,
  TError,
  { data?: VMQuotesPost },
  TContext
> => {
  return useMutation(
    getPostApi3pqCpqV1QuotesMutationOptions(options),
    queryClient,
  );
};

export type getApi3pqCpqV1QuotesResponse200 = {
  data: void;
  status: 200;
};

export type getApi3pqCpqV1QuotesResponseSuccess =
  getApi3pqCpqV1QuotesResponse200 & {
    headers: Headers;
  };
export const getGetApi3pqCpqV1QuotesUrl = () => {
  return `/api/3pq-cpq/v1/quotes`;
};

export const getApi3pqCpqV1Quotes = async (
  options?: RequestInit,
): Promise<getApi3pqCpqV1QuotesResponseSuccess> => {
  const res = await fetch(getGetApi3pqCpqV1QuotesUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } =
      new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: getApi3pqCpqV1QuotesResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApi3pqCpqV1QuotesResponseSuccess;
};

export const getGetApi3pqCpqV1QuotesQueryKey = () => {
  return [`/api/3pq-cpq/v1/quotes`] as const;
};

export const getGetApi3pqCpqV1QuotesQueryOptions = <
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApi3pqCpqV1QuotesQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>
  > = ({ signal }) => getApi3pqCpqV1Quotes({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApi3pqCpqV1QuotesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>
>;
export type GetApi3pqCpqV1QuotesQueryError = globalThis.Error & {
  info?: unknown;
  status?: number;
};

export function useGetApi3pqCpqV1Quotes<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
          TError,
          Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApi3pqCpqV1Quotes<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
          TError,
          Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApi3pqCpqV1Quotes<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApi3pqCpqV1Quotes<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1Quotes>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApi3pqCpqV1QuotesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getApi3pqCpqV1QuotesIdResponse200 = {
  data: void;
  status: 200;
};

export type getApi3pqCpqV1QuotesIdResponseSuccess =
  getApi3pqCpqV1QuotesIdResponse200 & {
    headers: Headers;
  };
export const getGetApi3pqCpqV1QuotesIdUrl = (id: string) => {
  return `/api/3pq-cpq/v1/quotes/${id}`;
};

export const getApi3pqCpqV1QuotesId = async (
  id: string,
  options?: RequestInit,
): Promise<getApi3pqCpqV1QuotesIdResponseSuccess> => {
  const res = await fetch(getGetApi3pqCpqV1QuotesIdUrl(id), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } =
      new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: getApi3pqCpqV1QuotesIdResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApi3pqCpqV1QuotesIdResponseSuccess;
};

export const getGetApi3pqCpqV1QuotesIdQueryKey = (id: string) => {
  return [`/api/3pq-cpq/v1/quotes/${id}`] as const;
};

export const getGetApi3pqCpqV1QuotesIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApi3pqCpqV1QuotesIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>
  > = ({ signal }) => getApi3pqCpqV1QuotesId(id, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApi3pqCpqV1QuotesIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>
>;
export type GetApi3pqCpqV1QuotesIdQueryError = globalThis.Error & {
  info?: unknown;
  status?: number;
};

export function useGetApi3pqCpqV1QuotesId<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
          TError,
          Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApi3pqCpqV1QuotesId<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
          TError,
          Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApi3pqCpqV1QuotesId<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApi3pqCpqV1QuotesId<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1QuotesId>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApi3pqCpqV1QuotesIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getApi3pqCpqV1QuotesGetactiveResponse200 = {
  data: void;
  status: 200;
};

export type getApi3pqCpqV1QuotesGetactiveResponseSuccess =
  getApi3pqCpqV1QuotesGetactiveResponse200 & {
    headers: Headers;
  };
export const getGetApi3pqCpqV1QuotesGetactiveUrl = () => {
  return `/api/3pq-cpq/v1/quotes/getactive`;
};

export const getApi3pqCpqV1QuotesGetactive = async (
  options?: RequestInit,
): Promise<getApi3pqCpqV1QuotesGetactiveResponseSuccess> => {
  const res = await fetch(getGetApi3pqCpqV1QuotesGetactiveUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } =
      new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: getApi3pqCpqV1QuotesGetactiveResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApi3pqCpqV1QuotesGetactiveResponseSuccess;
};

export const getGetApi3pqCpqV1QuotesGetactiveQueryKey = () => {
  return [`/api/3pq-cpq/v1/quotes/getactive`] as const;
};

export const getGetApi3pqCpqV1QuotesGetactiveQueryOptions = <
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApi3pqCpqV1QuotesGetactiveQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>
  > = ({ signal }) =>
    getApi3pqCpqV1QuotesGetactive({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApi3pqCpqV1QuotesGetactiveQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>
>;
export type GetApi3pqCpqV1QuotesGetactiveQueryError = globalThis.Error & {
  info?: unknown;
  status?: number;
};

export function useGetApi3pqCpqV1QuotesGetactive<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
          TError,
          Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApi3pqCpqV1QuotesGetactive<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
          TError,
          Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApi3pqCpqV1QuotesGetactive<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApi3pqCpqV1QuotesGetactive<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1QuotesGetactive>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApi3pqCpqV1QuotesGetactiveQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getApiQuoteApiGetQuoteIdResponse200TextPlain = {
  data: string;
  status: 200;
};

export type getApiQuoteApiGetQuoteIdResponse200ApplicationJson = {
  data: string;
  status: 200;
};

export type getApiQuoteApiGetQuoteIdResponse200TextJson = {
  data: string;
  status: 200;
};

export type getApiQuoteApiGetQuoteIdResponseSuccess = (
  | getApiQuoteApiGetQuoteIdResponse200TextPlain
  | getApiQuoteApiGetQuoteIdResponse200ApplicationJson
  | getApiQuoteApiGetQuoteIdResponse200TextJson
) & {
  headers: Headers;
};
export const getGetApiQuoteApiGetQuoteIdUrl = () => {
  return `/api/QuoteApi/GetQuoteId`;
};

export const getApiQuoteApiGetQuoteId = async (
  options?: RequestInit,
): Promise<getApiQuoteApiGetQuoteIdResponseSuccess> => {
  const res = await fetch(getGetApiQuoteApiGetQuoteIdUrl(), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } =
      new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: getApiQuoteApiGetQuoteIdResponseSuccess["data"] = body
    ? contentType.includes("json")
      ? JSON.parse(body)
      : body
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiQuoteApiGetQuoteIdResponseSuccess;
};

export const getGetApiQuoteApiGetQuoteIdQueryKey = () => {
  return [`/api/QuoteApi/GetQuoteId`] as const;
};

export const getGetApiQuoteApiGetQuoteIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiQuoteApiGetQuoteIdQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>
  > = ({ signal }) => getApiQuoteApiGetQuoteId({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiQuoteApiGetQuoteIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>
>;
export type GetApiQuoteApiGetQuoteIdQueryError = globalThis.Error & {
  info?: unknown;
  status?: number;
};

export function useGetApiQuoteApiGetQuoteId<
  TData = Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
          TError,
          Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiQuoteApiGetQuoteId<
  TData = Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
          TError,
          Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiQuoteApiGetQuoteId<
  TData = Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiQuoteApiGetQuoteId<
  TData = Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiGetQuoteId>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiQuoteApiGetQuoteIdQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getApiQuoteApiConvertSessionFromEasyIdResponse200 = {
  data: void;
  status: 200;
};

export type getApiQuoteApiConvertSessionFromEasyIdResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiQuoteApiConvertSessionFromEasyIdResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiQuoteApiConvertSessionFromEasyIdResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiQuoteApiConvertSessionFromEasyIdResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiQuoteApiConvertSessionFromEasyIdResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiQuoteApiConvertSessionFromEasyIdResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiQuoteApiConvertSessionFromEasyIdResponseSuccess =
  getApiQuoteApiConvertSessionFromEasyIdResponse200 & {
    headers: Headers;
  };
export type getApiQuoteApiConvertSessionFromEasyIdResponseError = (
  | getApiQuoteApiConvertSessionFromEasyIdResponse400TextPlain
  | getApiQuoteApiConvertSessionFromEasyIdResponse400ApplicationJson
  | getApiQuoteApiConvertSessionFromEasyIdResponse400TextJson
  | getApiQuoteApiConvertSessionFromEasyIdResponse401TextPlain
  | getApiQuoteApiConvertSessionFromEasyIdResponse401ApplicationJson
  | getApiQuoteApiConvertSessionFromEasyIdResponse401TextJson
) & {
  headers: Headers;
};

export const getGetApiQuoteApiConvertSessionFromEasyIdUrl = (id: string) => {
  return `/api/QuoteApi/ConvertSessionFromEasy/${id}`;
};

export const getApiQuoteApiConvertSessionFromEasyId = async (
  id: string,
  options?: RequestInit,
): Promise<getApiQuoteApiConvertSessionFromEasyIdResponseSuccess> => {
  const res = await fetch(getGetApiQuoteApiConvertSessionFromEasyIdUrl(id), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: getApiQuoteApiConvertSessionFromEasyIdResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: getApiQuoteApiConvertSessionFromEasyIdResponseError["data"] =
      body ? (errorContentType.includes("json") ? JSON.parse(body) : body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: getApiQuoteApiConvertSessionFromEasyIdResponseSuccess["data"] =
    body ? JSON.parse(body) : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiQuoteApiConvertSessionFromEasyIdResponseSuccess;
};

export const getGetApiQuoteApiConvertSessionFromEasyIdQueryKey = (
  id: string,
) => {
  return [`/api/QuoteApi/ConvertSessionFromEasy/${id}`] as const;
};

export const getGetApiQuoteApiConvertSessionFromEasyIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetApiQuoteApiConvertSessionFromEasyIdQueryKey(id);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>
  > = ({ signal }) =>
    getApiQuoteApiConvertSessionFromEasyId(id, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiQuoteApiConvertSessionFromEasyIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>
>;
export type GetApiQuoteApiConvertSessionFromEasyIdQueryError =
  globalThis.Error & { info?: ProblemDetails; status?: number };

export function useGetApiQuoteApiConvertSessionFromEasyId<
  TData = Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
          TError,
          Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiQuoteApiConvertSessionFromEasyId<
  TData = Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
          TError,
          Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiQuoteApiConvertSessionFromEasyId<
  TData = Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiQuoteApiConvertSessionFromEasyId<
  TData = Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiConvertSessionFromEasyId>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiQuoteApiConvertSessionFromEasyIdQueryOptions(
    id,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getApiQuoteApiLanguageResponse200TextPlain = {
  data: ReturnedString;
  status: 200;
};

export type getApiQuoteApiLanguageResponse200ApplicationJson = {
  data: ReturnedString;
  status: 200;
};

export type getApiQuoteApiLanguageResponse200TextJson = {
  data: ReturnedString;
  status: 200;
};

export type getApiQuoteApiLanguageResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiQuoteApiLanguageResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiQuoteApiLanguageResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiQuoteApiLanguageResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiQuoteApiLanguageResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiQuoteApiLanguageResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiQuoteApiLanguageResponseSuccess = (
  | getApiQuoteApiLanguageResponse200TextPlain
  | getApiQuoteApiLanguageResponse200ApplicationJson
  | getApiQuoteApiLanguageResponse200TextJson
) & {
  headers: Headers;
};
export type getApiQuoteApiLanguageResponseError = (
  | getApiQuoteApiLanguageResponse400TextPlain
  | getApiQuoteApiLanguageResponse400ApplicationJson
  | getApiQuoteApiLanguageResponse400TextJson
  | getApiQuoteApiLanguageResponse401TextPlain
  | getApiQuoteApiLanguageResponse401ApplicationJson
  | getApiQuoteApiLanguageResponse401TextJson
) & {
  headers: Headers;
};

export const getGetApiQuoteApiLanguageUrl = () => {
  return `/api/QuoteApi/Language`;
};

export const getApiQuoteApiLanguage = async (
  options?: RequestInit,
): Promise<getApiQuoteApiLanguageResponseSuccess> => {
  const res = await fetch(getGetApiQuoteApiLanguageUrl(), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: getApiQuoteApiLanguageResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: getApiQuoteApiLanguageResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: getApiQuoteApiLanguageResponseSuccess["data"] = body
    ? contentType.includes("json")
      ? JSON.parse(body)
      : body
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiQuoteApiLanguageResponseSuccess;
};

export const getGetApiQuoteApiLanguageQueryKey = () => {
  return [`/api/QuoteApi/Language`] as const;
};

export const getGetApiQuoteApiLanguageQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiQuoteApiLanguageQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiQuoteApiLanguage>>
  > = ({ signal }) => getApiQuoteApiLanguage({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiQuoteApiLanguageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiQuoteApiLanguage>>
>;
export type GetApiQuoteApiLanguageQueryError = globalThis.Error & {
  info?: ProblemDetails;
  status?: number;
};

export function useGetApiQuoteApiLanguage<
  TData = Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
          TError,
          Awaited<ReturnType<typeof getApiQuoteApiLanguage>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiQuoteApiLanguage<
  TData = Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
          TError,
          Awaited<ReturnType<typeof getApiQuoteApiLanguage>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiQuoteApiLanguage<
  TData = Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiQuoteApiLanguage<
  TData = Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiLanguage>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiQuoteApiLanguageQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type putApiQuoteApiLanguageResponse200 = {
  data: void;
  status: 200;
};

export type putApiQuoteApiLanguageResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type putApiQuoteApiLanguageResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type putApiQuoteApiLanguageResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type putApiQuoteApiLanguageResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type putApiQuoteApiLanguageResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type putApiQuoteApiLanguageResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type putApiQuoteApiLanguageResponseSuccess =
  putApiQuoteApiLanguageResponse200 & {
    headers: Headers;
  };
export type putApiQuoteApiLanguageResponseError = (
  | putApiQuoteApiLanguageResponse400TextPlain
  | putApiQuoteApiLanguageResponse400ApplicationJson
  | putApiQuoteApiLanguageResponse400TextJson
  | putApiQuoteApiLanguageResponse401TextPlain
  | putApiQuoteApiLanguageResponse401ApplicationJson
  | putApiQuoteApiLanguageResponse401TextJson
) & {
  headers: Headers;
};

export const getPutApiQuoteApiLanguageUrl = () => {
  return `/api/QuoteApi/Language`;
};

export const putApiQuoteApiLanguage = async (
  languageCodeClass?: LanguageCodeClass,
  options?: RequestInit,
): Promise<putApiQuoteApiLanguageResponseSuccess> => {
  const res = await fetch(getPutApiQuoteApiLanguageUrl(), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(languageCodeClass),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: putApiQuoteApiLanguageResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: putApiQuoteApiLanguageResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: putApiQuoteApiLanguageResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as putApiQuoteApiLanguageResponseSuccess;
};

export const getPutApiQuoteApiLanguageMutationOptions = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiQuoteApiLanguage>>,
    TError,
    { data?: LanguageCodeClass },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiQuoteApiLanguage>>,
  TError,
  { data?: LanguageCodeClass },
  TContext
> => {
  const mutationKey = ["putApiQuoteApiLanguage"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiQuoteApiLanguage>>,
    { data?: LanguageCodeClass }
  > = (props) => {
    const { data } = props ?? {};

    return putApiQuoteApiLanguage(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiQuoteApiLanguageMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiQuoteApiLanguage>>
>;
export type PutApiQuoteApiLanguageMutationBody = LanguageCodeClass | undefined;
export type PutApiQuoteApiLanguageMutationError = globalThis.Error & {
  info?: ProblemDetails;
  status?: number;
};

export const usePutApiQuoteApiLanguage = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiQuoteApiLanguage>>,
      TError,
      { data?: LanguageCodeClass },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putApiQuoteApiLanguage>>,
  TError,
  { data?: LanguageCodeClass },
  TContext
> => {
  return useMutation(
    getPutApiQuoteApiLanguageMutationOptions(options),
    queryClient,
  );
};

export type getApiQuoteApiCleanProjectListResponse200 = {
  data: void;
  status: 200;
};

export type getApiQuoteApiCleanProjectListResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiQuoteApiCleanProjectListResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiQuoteApiCleanProjectListResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiQuoteApiCleanProjectListResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiQuoteApiCleanProjectListResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiQuoteApiCleanProjectListResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiQuoteApiCleanProjectListResponseSuccess =
  getApiQuoteApiCleanProjectListResponse200 & {
    headers: Headers;
  };
export type getApiQuoteApiCleanProjectListResponseError = (
  | getApiQuoteApiCleanProjectListResponse400TextPlain
  | getApiQuoteApiCleanProjectListResponse400ApplicationJson
  | getApiQuoteApiCleanProjectListResponse400TextJson
  | getApiQuoteApiCleanProjectListResponse401TextPlain
  | getApiQuoteApiCleanProjectListResponse401ApplicationJson
  | getApiQuoteApiCleanProjectListResponse401TextJson
) & {
  headers: Headers;
};

export const getGetApiQuoteApiCleanProjectListUrl = () => {
  return `/api/QuoteApi/CleanProjectList`;
};

export const getApiQuoteApiCleanProjectList = async (
  options?: RequestInit,
): Promise<getApiQuoteApiCleanProjectListResponseSuccess> => {
  const res = await fetch(getGetApiQuoteApiCleanProjectListUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: getApiQuoteApiCleanProjectListResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: getApiQuoteApiCleanProjectListResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: getApiQuoteApiCleanProjectListResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiQuoteApiCleanProjectListResponseSuccess;
};

export const getGetApiQuoteApiCleanProjectListQueryKey = () => {
  return [`/api/QuoteApi/CleanProjectList`] as const;
};

export const getGetApiQuoteApiCleanProjectListQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiQuoteApiCleanProjectListQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>
  > = ({ signal }) =>
    getApiQuoteApiCleanProjectList({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiQuoteApiCleanProjectListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>
>;
export type GetApiQuoteApiCleanProjectListQueryError = globalThis.Error & {
  info?: ProblemDetails;
  status?: number;
};

export function useGetApiQuoteApiCleanProjectList<
  TData = Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
          TError,
          Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiQuoteApiCleanProjectList<
  TData = Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
          TError,
          Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiQuoteApiCleanProjectList<
  TData = Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiQuoteApiCleanProjectList<
  TData = Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiQuoteApiCleanProjectList>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiQuoteApiCleanProjectListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type deleteApiQuoteApiDeleteEmptyQuotesResponse200 = {
  data: void;
  status: 200;
};

export type deleteApiQuoteApiDeleteEmptyQuotesResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type deleteApiQuoteApiDeleteEmptyQuotesResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type deleteApiQuoteApiDeleteEmptyQuotesResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type deleteApiQuoteApiDeleteEmptyQuotesResponseSuccess =
  deleteApiQuoteApiDeleteEmptyQuotesResponse200 & {
    headers: Headers;
  };
export type deleteApiQuoteApiDeleteEmptyQuotesResponseError = (
  | deleteApiQuoteApiDeleteEmptyQuotesResponse401TextPlain
  | deleteApiQuoteApiDeleteEmptyQuotesResponse401ApplicationJson
  | deleteApiQuoteApiDeleteEmptyQuotesResponse401TextJson
) & {
  headers: Headers;
};

export const getDeleteApiQuoteApiDeleteEmptyQuotesUrl = (
  params?: DeleteApiQuoteApiDeleteEmptyQuotesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/QuoteApi/DeleteEmptyQuotes?${stringifiedParams}`
    : `/api/QuoteApi/DeleteEmptyQuotes`;
};

export const deleteApiQuoteApiDeleteEmptyQuotes = async (
  params?: DeleteApiQuoteApiDeleteEmptyQuotesParams,
  options?: RequestInit,
): Promise<deleteApiQuoteApiDeleteEmptyQuotesResponseSuccess> => {
  const res = await fetch(getDeleteApiQuoteApiDeleteEmptyQuotesUrl(params), {
    ...options,
    method: "DELETE",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: deleteApiQuoteApiDeleteEmptyQuotesResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: deleteApiQuoteApiDeleteEmptyQuotesResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: deleteApiQuoteApiDeleteEmptyQuotesResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as deleteApiQuoteApiDeleteEmptyQuotesResponseSuccess;
};

export const getDeleteApiQuoteApiDeleteEmptyQuotesMutationOptions = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiQuoteApiDeleteEmptyQuotes>>,
    TError,
    { params?: DeleteApiQuoteApiDeleteEmptyQuotesParams },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiQuoteApiDeleteEmptyQuotes>>,
  TError,
  { params?: DeleteApiQuoteApiDeleteEmptyQuotesParams },
  TContext
> => {
  const mutationKey = ["deleteApiQuoteApiDeleteEmptyQuotes"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiQuoteApiDeleteEmptyQuotes>>,
    { params?: DeleteApiQuoteApiDeleteEmptyQuotesParams }
  > = (props) => {
    const { params } = props ?? {};

    return deleteApiQuoteApiDeleteEmptyQuotes(params, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiQuoteApiDeleteEmptyQuotesMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiQuoteApiDeleteEmptyQuotes>>
>;

export type DeleteApiQuoteApiDeleteEmptyQuotesMutationError =
  globalThis.Error & { info?: ProblemDetails; status?: number };

export const useDeleteApiQuoteApiDeleteEmptyQuotes = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiQuoteApiDeleteEmptyQuotes>>,
      TError,
      { params?: DeleteApiQuoteApiDeleteEmptyQuotesParams },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiQuoteApiDeleteEmptyQuotes>>,
  TError,
  { params?: DeleteApiQuoteApiDeleteEmptyQuotesParams },
  TContext
> => {
  return useMutation(
    getDeleteApiQuoteApiDeleteEmptyQuotesMutationOptions(options),
    queryClient,
  );
};

export type getApi3pqCpqV1StatusIdResponse200 = {
  data: void;
  status: 200;
};

export type getApi3pqCpqV1StatusIdResponseSuccess =
  getApi3pqCpqV1StatusIdResponse200 & {
    headers: Headers;
  };
export const getGetApi3pqCpqV1StatusIdUrl = (
  id: string,
  params?: GetApi3pqCpqV1StatusIdParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["languageId"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? "null" : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/3pq-cpq/v1/status/${id}?${stringifiedParams}`
    : `/api/3pq-cpq/v1/status/${id}`;
};

export const getApi3pqCpqV1StatusId = async (
  id: string,
  params?: GetApi3pqCpqV1StatusIdParams,
  options?: RequestInit,
): Promise<getApi3pqCpqV1StatusIdResponseSuccess> => {
  const res = await fetch(getGetApi3pqCpqV1StatusIdUrl(id, params), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } =
      new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: getApi3pqCpqV1StatusIdResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApi3pqCpqV1StatusIdResponseSuccess;
};

export const getGetApi3pqCpqV1StatusIdQueryKey = (
  id: string,
  params?: GetApi3pqCpqV1StatusIdParams,
) => {
  return [`/api/3pq-cpq/v1/status/${id}`, ...(params ? [params] : [])] as const;
};

export const getGetApi3pqCpqV1StatusIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  id: string,
  params?: GetApi3pqCpqV1StatusIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApi3pqCpqV1StatusIdQueryKey(id, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>
  > = ({ signal }) =>
    getApi3pqCpqV1StatusId(id, params, { signal, ...fetchOptions });

  return {
    queryKey,
    queryFn,
    enabled: id !== null && id !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApi3pqCpqV1StatusIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>
>;
export type GetApi3pqCpqV1StatusIdQueryError = globalThis.Error & {
  info?: unknown;
  status?: number;
};

export function useGetApi3pqCpqV1StatusId<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  id: string,
  params: undefined | GetApi3pqCpqV1StatusIdParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
          TError,
          Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApi3pqCpqV1StatusId<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  id: string,
  params?: GetApi3pqCpqV1StatusIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
          TError,
          Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApi3pqCpqV1StatusId<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  id: string,
  params?: GetApi3pqCpqV1StatusIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApi3pqCpqV1StatusId<
  TData = Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  id: string,
  params?: GetApi3pqCpqV1StatusIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApi3pqCpqV1StatusId>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApi3pqCpqV1StatusIdQueryOptions(
    id,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getApiTestResponse200 = {
  data: void;
  status: 200;
};

export type getApiTestResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestResponseSuccess = getApiTestResponse200 & {
  headers: Headers;
};
export type getApiTestResponseError = (
  | getApiTestResponse400TextPlain
  | getApiTestResponse400ApplicationJson
  | getApiTestResponse400TextJson
  | getApiTestResponse401TextPlain
  | getApiTestResponse401ApplicationJson
  | getApiTestResponse401TextJson
) & {
  headers: Headers;
};

export const getGetApiTestUrl = () => {
  return `/api/Test`;
};

export const getApiTest = async (
  options?: RequestInit,
): Promise<getApiTestResponseSuccess> => {
  const res = await fetch(getGetApiTestUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: getApiTestResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: getApiTestResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: getApiTestResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiTestResponseSuccess;
};

export const getGetApiTestQueryKey = () => {
  return [`/api/Test`] as const;
};

export const getGetApiTestQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTest>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getApiTest>>, TError, TData>
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTestQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTest>>> = ({
    signal,
  }) => getApiTest({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTest>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTestQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTest>>
>;
export type GetApiTestQueryError = globalThis.Error & {
  info?: ProblemDetails;
  status?: number;
};

export function useGetApiTest<
  TData = Awaited<ReturnType<typeof getApiTest>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTest>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTest>>,
          TError,
          Awaited<ReturnType<typeof getApiTest>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTest<
  TData = Awaited<ReturnType<typeof getApiTest>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTest>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTest>>,
          TError,
          Awaited<ReturnType<typeof getApiTest>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTest<
  TData = Awaited<ReturnType<typeof getApiTest>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTest>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTest<
  TData = Awaited<ReturnType<typeof getApiTest>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTest>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTestQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getApiTestJWTtokenResponse200 = {
  data: void;
  status: 200;
};

export type getApiTestJWTtokenResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestJWTtokenResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestJWTtokenResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestJWTtokenResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestJWTtokenResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestJWTtokenResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestJWTtokenResponseSuccess =
  getApiTestJWTtokenResponse200 & {
    headers: Headers;
  };
export type getApiTestJWTtokenResponseError = (
  | getApiTestJWTtokenResponse400TextPlain
  | getApiTestJWTtokenResponse400ApplicationJson
  | getApiTestJWTtokenResponse400TextJson
  | getApiTestJWTtokenResponse401TextPlain
  | getApiTestJWTtokenResponse401ApplicationJson
  | getApiTestJWTtokenResponse401TextJson
) & {
  headers: Headers;
};

export const getGetApiTestJWTtokenUrl = () => {
  return `/api/Test/JWTtoken`;
};

export const getApiTestJWTtoken = async (
  options?: RequestInit,
): Promise<getApiTestJWTtokenResponseSuccess> => {
  const res = await fetch(getGetApiTestJWTtokenUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: getApiTestJWTtokenResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: getApiTestJWTtokenResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: getApiTestJWTtokenResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiTestJWTtokenResponseSuccess;
};

export const getGetApiTestJWTtokenQueryKey = () => {
  return [`/api/Test/JWTtoken`] as const;
};

export const getGetApiTestJWTtokenQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTestJWTtoken>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiTestJWTtoken>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTestJWTtokenQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTestJWTtoken>>
  > = ({ signal }) => getApiTestJWTtoken({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTestJWTtoken>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTestJWTtokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTestJWTtoken>>
>;
export type GetApiTestJWTtokenQueryError = globalThis.Error & {
  info?: ProblemDetails;
  status?: number;
};

export function useGetApiTestJWTtoken<
  TData = Awaited<ReturnType<typeof getApiTestJWTtoken>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestJWTtoken>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestJWTtoken>>,
          TError,
          Awaited<ReturnType<typeof getApiTestJWTtoken>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestJWTtoken<
  TData = Awaited<ReturnType<typeof getApiTestJWTtoken>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestJWTtoken>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestJWTtoken>>,
          TError,
          Awaited<ReturnType<typeof getApiTestJWTtoken>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestJWTtoken<
  TData = Awaited<ReturnType<typeof getApiTestJWTtoken>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestJWTtoken>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTestJWTtoken<
  TData = Awaited<ReturnType<typeof getApiTestJWTtoken>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestJWTtoken>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTestJWTtokenQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getApiTestJWTtoken2Response200 = {
  data: void;
  status: 200;
};

export type getApiTestJWTtoken2Response400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestJWTtoken2Response400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestJWTtoken2Response400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestJWTtoken2Response401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestJWTtoken2Response401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestJWTtoken2Response401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestJWTtoken2ResponseSuccess =
  getApiTestJWTtoken2Response200 & {
    headers: Headers;
  };
export type getApiTestJWTtoken2ResponseError = (
  | getApiTestJWTtoken2Response400TextPlain
  | getApiTestJWTtoken2Response400ApplicationJson
  | getApiTestJWTtoken2Response400TextJson
  | getApiTestJWTtoken2Response401TextPlain
  | getApiTestJWTtoken2Response401ApplicationJson
  | getApiTestJWTtoken2Response401TextJson
) & {
  headers: Headers;
};

export const getGetApiTestJWTtoken2Url = () => {
  return `/api/Test/JWTtoken2`;
};

export const getApiTestJWTtoken2 = async (
  options?: RequestInit,
): Promise<getApiTestJWTtoken2ResponseSuccess> => {
  const res = await fetch(getGetApiTestJWTtoken2Url(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: getApiTestJWTtoken2ResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: getApiTestJWTtoken2ResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: getApiTestJWTtoken2ResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiTestJWTtoken2ResponseSuccess;
};

export const getGetApiTestJWTtoken2QueryKey = () => {
  return [`/api/Test/JWTtoken2`] as const;
};

export const getGetApiTestJWTtoken2QueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTestJWTtoken2QueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTestJWTtoken2>>
  > = ({ signal }) => getApiTestJWTtoken2({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTestJWTtoken2QueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTestJWTtoken2>>
>;
export type GetApiTestJWTtoken2QueryError = globalThis.Error & {
  info?: ProblemDetails;
  status?: number;
};

export function useGetApiTestJWTtoken2<
  TData = Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
          TError,
          Awaited<ReturnType<typeof getApiTestJWTtoken2>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestJWTtoken2<
  TData = Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
          TError,
          Awaited<ReturnType<typeof getApiTestJWTtoken2>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestJWTtoken2<
  TData = Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTestJWTtoken2<
  TData = Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestJWTtoken2>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTestJWTtoken2QueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getApiTestNameResponse200 = {
  data: void;
  status: 200;
};

export type getApiTestNameResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestNameResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestNameResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestNameResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestNameResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestNameResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestNameResponseSuccess = getApiTestNameResponse200 & {
  headers: Headers;
};
export type getApiTestNameResponseError = (
  | getApiTestNameResponse400TextPlain
  | getApiTestNameResponse400ApplicationJson
  | getApiTestNameResponse400TextJson
  | getApiTestNameResponse401TextPlain
  | getApiTestNameResponse401ApplicationJson
  | getApiTestNameResponse401TextJson
) & {
  headers: Headers;
};

export const getGetApiTestNameUrl = () => {
  return `/api/Test/name`;
};

export const getApiTestName = async (
  options?: RequestInit,
): Promise<getApiTestNameResponseSuccess> => {
  const res = await fetch(getGetApiTestNameUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: getApiTestNameResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: getApiTestNameResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: getApiTestNameResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiTestNameResponseSuccess;
};

export const getGetApiTestNameQueryKey = () => {
  return [`/api/Test/name`] as const;
};

export const getGetApiTestNameQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTestName>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getApiTestName>>, TError, TData>
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTestNameQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTestName>>> = ({
    signal,
  }) => getApiTestName({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTestName>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTestNameQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTestName>>
>;
export type GetApiTestNameQueryError = globalThis.Error & {
  info?: ProblemDetails;
  status?: number;
};

export function useGetApiTestName<
  TData = Awaited<ReturnType<typeof getApiTestName>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTestName>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestName>>,
          TError,
          Awaited<ReturnType<typeof getApiTestName>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestName<
  TData = Awaited<ReturnType<typeof getApiTestName>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTestName>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestName>>,
          TError,
          Awaited<ReturnType<typeof getApiTestName>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestName<
  TData = Awaited<ReturnType<typeof getApiTestName>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTestName>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTestName<
  TData = Awaited<ReturnType<typeof getApiTestName>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTestName>>, TError, TData>
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTestNameQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getApiTestEasyTokenResponse200 = {
  data: void;
  status: 200;
};

export type getApiTestEasyTokenResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestEasyTokenResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestEasyTokenResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestEasyTokenResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestEasyTokenResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestEasyTokenResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestEasyTokenResponseSuccess =
  getApiTestEasyTokenResponse200 & {
    headers: Headers;
  };
export type getApiTestEasyTokenResponseError = (
  | getApiTestEasyTokenResponse400TextPlain
  | getApiTestEasyTokenResponse400ApplicationJson
  | getApiTestEasyTokenResponse400TextJson
  | getApiTestEasyTokenResponse401TextPlain
  | getApiTestEasyTokenResponse401ApplicationJson
  | getApiTestEasyTokenResponse401TextJson
) & {
  headers: Headers;
};

export const getGetApiTestEasyTokenUrl = () => {
  return `/api/Test/EasyToken`;
};

export const getApiTestEasyToken = async (
  options?: RequestInit,
): Promise<getApiTestEasyTokenResponseSuccess> => {
  const res = await fetch(getGetApiTestEasyTokenUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: getApiTestEasyTokenResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: getApiTestEasyTokenResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: getApiTestEasyTokenResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiTestEasyTokenResponseSuccess;
};

export const getGetApiTestEasyTokenQueryKey = () => {
  return [`/api/Test/EasyToken`] as const;
};

export const getGetApiTestEasyTokenQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTestEasyToken>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiTestEasyToken>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTestEasyTokenQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTestEasyToken>>
  > = ({ signal }) => getApiTestEasyToken({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTestEasyToken>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTestEasyTokenQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTestEasyToken>>
>;
export type GetApiTestEasyTokenQueryError = globalThis.Error & {
  info?: ProblemDetails;
  status?: number;
};

export function useGetApiTestEasyToken<
  TData = Awaited<ReturnType<typeof getApiTestEasyToken>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestEasyToken>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestEasyToken>>,
          TError,
          Awaited<ReturnType<typeof getApiTestEasyToken>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestEasyToken<
  TData = Awaited<ReturnType<typeof getApiTestEasyToken>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestEasyToken>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestEasyToken>>,
          TError,
          Awaited<ReturnType<typeof getApiTestEasyToken>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestEasyToken<
  TData = Awaited<ReturnType<typeof getApiTestEasyToken>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestEasyToken>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTestEasyToken<
  TData = Awaited<ReturnType<typeof getApiTestEasyToken>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestEasyToken>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTestEasyTokenQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type postApiTestConvertToSingleUseTokenResponse200 = {
  data: void;
  status: 200;
};

export type postApiTestConvertToSingleUseTokenResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestConvertToSingleUseTokenResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestConvertToSingleUseTokenResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestConvertToSingleUseTokenResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestConvertToSingleUseTokenResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestConvertToSingleUseTokenResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestConvertToSingleUseTokenResponseSuccess =
  postApiTestConvertToSingleUseTokenResponse200 & {
    headers: Headers;
  };
export type postApiTestConvertToSingleUseTokenResponseError = (
  | postApiTestConvertToSingleUseTokenResponse400TextPlain
  | postApiTestConvertToSingleUseTokenResponse400ApplicationJson
  | postApiTestConvertToSingleUseTokenResponse400TextJson
  | postApiTestConvertToSingleUseTokenResponse401TextPlain
  | postApiTestConvertToSingleUseTokenResponse401ApplicationJson
  | postApiTestConvertToSingleUseTokenResponse401TextJson
) & {
  headers: Headers;
};

export const getPostApiTestConvertToSingleUseTokenUrl = () => {
  return `/api/Test/ConvertToSingleUseToken`;
};

export const postApiTestConvertToSingleUseToken = async (
  convertTokenInput?: ConvertTokenInput,
  options?: RequestInit,
): Promise<postApiTestConvertToSingleUseTokenResponseSuccess> => {
  const res = await fetch(getPostApiTestConvertToSingleUseTokenUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(convertTokenInput),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: postApiTestConvertToSingleUseTokenResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: postApiTestConvertToSingleUseTokenResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: postApiTestConvertToSingleUseTokenResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiTestConvertToSingleUseTokenResponseSuccess;
};

export const getPostApiTestConvertToSingleUseTokenMutationOptions = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTestConvertToSingleUseToken>>,
    TError,
    { data?: ConvertTokenInput },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTestConvertToSingleUseToken>>,
  TError,
  { data?: ConvertTokenInput },
  TContext
> => {
  const mutationKey = ["postApiTestConvertToSingleUseToken"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTestConvertToSingleUseToken>>,
    { data?: ConvertTokenInput }
  > = (props) => {
    const { data } = props ?? {};

    return postApiTestConvertToSingleUseToken(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTestConvertToSingleUseTokenMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTestConvertToSingleUseToken>>
>;
export type PostApiTestConvertToSingleUseTokenMutationBody =
  ConvertTokenInput | undefined;
export type PostApiTestConvertToSingleUseTokenMutationError =
  globalThis.Error & { info?: ProblemDetails; status?: number };

export const usePostApiTestConvertToSingleUseToken = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTestConvertToSingleUseToken>>,
      TError,
      { data?: ConvertTokenInput },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTestConvertToSingleUseToken>>,
  TError,
  { data?: ConvertTokenInput },
  TContext
> => {
  return useMutation(
    getPostApiTestConvertToSingleUseTokenMutationOptions(options),
    queryClient,
  );
};

export type getApiTestJumpToEasyResponse200TextPlain = {
  data: VMEasyRedirect;
  status: 200;
};

export type getApiTestJumpToEasyResponse200ApplicationJson = {
  data: VMEasyRedirect;
  status: 200;
};

export type getApiTestJumpToEasyResponse200TextJson = {
  data: VMEasyRedirect;
  status: 200;
};

export type getApiTestJumpToEasyResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestJumpToEasyResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestJumpToEasyResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestJumpToEasyResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestJumpToEasyResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestJumpToEasyResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestJumpToEasyResponseSuccess = (
  | getApiTestJumpToEasyResponse200TextPlain
  | getApiTestJumpToEasyResponse200ApplicationJson
  | getApiTestJumpToEasyResponse200TextJson
) & {
  headers: Headers;
};
export type getApiTestJumpToEasyResponseError = (
  | getApiTestJumpToEasyResponse400TextPlain
  | getApiTestJumpToEasyResponse400ApplicationJson
  | getApiTestJumpToEasyResponse400TextJson
  | getApiTestJumpToEasyResponse401TextPlain
  | getApiTestJumpToEasyResponse401ApplicationJson
  | getApiTestJumpToEasyResponse401TextJson
) & {
  headers: Headers;
};

export const getGetApiTestJumpToEasyUrl = () => {
  return `/api/Test/JumpToEasy`;
};

export const getApiTestJumpToEasy = async (
  options?: RequestInit,
): Promise<getApiTestJumpToEasyResponseSuccess> => {
  const res = await fetch(getGetApiTestJumpToEasyUrl(), {
    ...options,
    method: "GET",
  });

  const contentType = (res.headers.get("content-type") ?? "").toLowerCase();
  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: getApiTestJumpToEasyResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: getApiTestJumpToEasyResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: getApiTestJumpToEasyResponseSuccess["data"] = body
    ? contentType.includes("json")
      ? JSON.parse(body)
      : body
    : {};
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiTestJumpToEasyResponseSuccess;
};

export const getGetApiTestJumpToEasyQueryKey = () => {
  return [`/api/Test/JumpToEasy`] as const;
};

export const getGetApiTestJumpToEasyQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTestJumpToEasyQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTestJumpToEasy>>
  > = ({ signal }) => getApiTestJumpToEasy({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTestJumpToEasyQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTestJumpToEasy>>
>;
export type GetApiTestJumpToEasyQueryError = globalThis.Error & {
  info?: ProblemDetails;
  status?: number;
};

export function useGetApiTestJumpToEasy<
  TData = Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
          TError,
          Awaited<ReturnType<typeof getApiTestJumpToEasy>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestJumpToEasy<
  TData = Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
          TError,
          Awaited<ReturnType<typeof getApiTestJumpToEasy>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestJumpToEasy<
  TData = Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTestJumpToEasy<
  TData = Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestJumpToEasy>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTestJumpToEasyQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type postApiTestWegTestCallResponse200 = {
  data: void;
  status: 200;
};

export type postApiTestWegTestCallResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestWegTestCallResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestWegTestCallResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestWegTestCallResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestWegTestCallResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestWegTestCallResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestWegTestCallResponseSuccess =
  postApiTestWegTestCallResponse200 & {
    headers: Headers;
  };
export type postApiTestWegTestCallResponseError = (
  | postApiTestWegTestCallResponse400TextPlain
  | postApiTestWegTestCallResponse400ApplicationJson
  | postApiTestWegTestCallResponse400TextJson
  | postApiTestWegTestCallResponse401TextPlain
  | postApiTestWegTestCallResponse401ApplicationJson
  | postApiTestWegTestCallResponse401TextJson
) & {
  headers: Headers;
};

export const getPostApiTestWegTestCallUrl = () => {
  return `/api/Test/WegTestCall`;
};

export const postApiTestWegTestCall = async (
  wegTestCallInput?: WegTestCallInput,
  options?: RequestInit,
): Promise<postApiTestWegTestCallResponseSuccess> => {
  const res = await fetch(getPostApiTestWegTestCallUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(wegTestCallInput),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: postApiTestWegTestCallResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: postApiTestWegTestCallResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: postApiTestWegTestCallResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiTestWegTestCallResponseSuccess;
};

export const getPostApiTestWegTestCallMutationOptions = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTestWegTestCall>>,
    TError,
    { data?: WegTestCallInput },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTestWegTestCall>>,
  TError,
  { data?: WegTestCallInput },
  TContext
> => {
  const mutationKey = ["postApiTestWegTestCall"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTestWegTestCall>>,
    { data?: WegTestCallInput }
  > = (props) => {
    const { data } = props ?? {};

    return postApiTestWegTestCall(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTestWegTestCallMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTestWegTestCall>>
>;
export type PostApiTestWegTestCallMutationBody = WegTestCallInput | undefined;
export type PostApiTestWegTestCallMutationError = globalThis.Error & {
  info?: ProblemDetails;
  status?: number;
};

export const usePostApiTestWegTestCall = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTestWegTestCall>>,
      TError,
      { data?: WegTestCallInput },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTestWegTestCall>>,
  TError,
  { data?: WegTestCallInput },
  TContext
> => {
  return useMutation(
    getPostApiTestWegTestCallMutationOptions(options),
    queryClient,
  );
};

export type getApiTestGetMockSessionResponse200 = {
  data: void;
  status: 200;
};

export type getApiTestGetMockSessionResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestGetMockSessionResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestGetMockSessionResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestGetMockSessionResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestGetMockSessionResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestGetMockSessionResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestGetMockSessionResponseSuccess =
  getApiTestGetMockSessionResponse200 & {
    headers: Headers;
  };
export type getApiTestGetMockSessionResponseError = (
  | getApiTestGetMockSessionResponse400TextPlain
  | getApiTestGetMockSessionResponse400ApplicationJson
  | getApiTestGetMockSessionResponse400TextJson
  | getApiTestGetMockSessionResponse401TextPlain
  | getApiTestGetMockSessionResponse401ApplicationJson
  | getApiTestGetMockSessionResponse401TextJson
) & {
  headers: Headers;
};

export const getGetApiTestGetMockSessionUrl = () => {
  return `/api/Test/GetMockSession`;
};

export const getApiTestGetMockSession = async (
  options?: RequestInit,
): Promise<getApiTestGetMockSessionResponseSuccess> => {
  const res = await fetch(getGetApiTestGetMockSessionUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: getApiTestGetMockSessionResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: getApiTestGetMockSessionResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: getApiTestGetMockSessionResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiTestGetMockSessionResponseSuccess;
};

export const getGetApiTestGetMockSessionQueryKey = () => {
  return [`/api/Test/GetMockSession`] as const;
};

export const getGetApiTestGetMockSessionQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTestGetMockSession>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiTestGetMockSession>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTestGetMockSessionQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTestGetMockSession>>
  > = ({ signal }) => getApiTestGetMockSession({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTestGetMockSession>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTestGetMockSessionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTestGetMockSession>>
>;
export type GetApiTestGetMockSessionQueryError = globalThis.Error & {
  info?: ProblemDetails;
  status?: number;
};

export function useGetApiTestGetMockSession<
  TData = Awaited<ReturnType<typeof getApiTestGetMockSession>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestGetMockSession>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestGetMockSession>>,
          TError,
          Awaited<ReturnType<typeof getApiTestGetMockSession>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestGetMockSession<
  TData = Awaited<ReturnType<typeof getApiTestGetMockSession>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestGetMockSession>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestGetMockSession>>,
          TError,
          Awaited<ReturnType<typeof getApiTestGetMockSession>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestGetMockSession<
  TData = Awaited<ReturnType<typeof getApiTestGetMockSession>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestGetMockSession>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTestGetMockSession<
  TData = Awaited<ReturnType<typeof getApiTestGetMockSession>>,
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestGetMockSession>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTestGetMockSessionQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type postApiTestMockEasySynchronizationResponse200 = {
  data: void;
  status: 200;
};

export type postApiTestMockEasySynchronizationResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestMockEasySynchronizationResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestMockEasySynchronizationResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestMockEasySynchronizationResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestMockEasySynchronizationResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestMockEasySynchronizationResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestMockEasySynchronizationResponseSuccess =
  postApiTestMockEasySynchronizationResponse200 & {
    headers: Headers;
  };
export type postApiTestMockEasySynchronizationResponseError = (
  | postApiTestMockEasySynchronizationResponse400TextPlain
  | postApiTestMockEasySynchronizationResponse400ApplicationJson
  | postApiTestMockEasySynchronizationResponse400TextJson
  | postApiTestMockEasySynchronizationResponse401TextPlain
  | postApiTestMockEasySynchronizationResponse401ApplicationJson
  | postApiTestMockEasySynchronizationResponse401TextJson
) & {
  headers: Headers;
};

export const getPostApiTestMockEasySynchronizationUrl = () => {
  return `/api/Test/MockEasySynchronization`;
};

export const postApiTestMockEasySynchronization = async (
  postApiTestMockEasySynchronizationBody?: string[],
  options?: RequestInit,
): Promise<postApiTestMockEasySynchronizationResponseSuccess> => {
  const res = await fetch(getPostApiTestMockEasySynchronizationUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(postApiTestMockEasySynchronizationBody),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: postApiTestMockEasySynchronizationResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: postApiTestMockEasySynchronizationResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: postApiTestMockEasySynchronizationResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiTestMockEasySynchronizationResponseSuccess;
};

export const getPostApiTestMockEasySynchronizationMutationOptions = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTestMockEasySynchronization>>,
    TError,
    { data?: string[] },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTestMockEasySynchronization>>,
  TError,
  { data?: string[] },
  TContext
> => {
  const mutationKey = ["postApiTestMockEasySynchronization"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTestMockEasySynchronization>>,
    { data?: string[] }
  > = (props) => {
    const { data } = props ?? {};

    return postApiTestMockEasySynchronization(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTestMockEasySynchronizationMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTestMockEasySynchronization>>
>;
export type PostApiTestMockEasySynchronizationMutationBody =
  string[] | undefined;
export type PostApiTestMockEasySynchronizationMutationError =
  globalThis.Error & { info?: ProblemDetails; status?: number };

export const usePostApiTestMockEasySynchronization = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTestMockEasySynchronization>>,
      TError,
      { data?: string[] },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTestMockEasySynchronization>>,
  TError,
  { data?: string[] },
  TContext
> => {
  return useMutation(
    getPostApiTestMockEasySynchronizationMutationOptions(options),
    queryClient,
  );
};

export type postApiTestTestEmailResponse200 = {
  data: void;
  status: 200;
};

export type postApiTestTestEmailResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestTestEmailResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestTestEmailResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestTestEmailResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestTestEmailResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestTestEmailResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestTestEmailResponseSuccess =
  postApiTestTestEmailResponse200 & {
    headers: Headers;
  };
export type postApiTestTestEmailResponseError = (
  | postApiTestTestEmailResponse400TextPlain
  | postApiTestTestEmailResponse400ApplicationJson
  | postApiTestTestEmailResponse400TextJson
  | postApiTestTestEmailResponse401TextPlain
  | postApiTestTestEmailResponse401ApplicationJson
  | postApiTestTestEmailResponse401TextJson
) & {
  headers: Headers;
};

export const getPostApiTestTestEmailUrl = () => {
  return `/api/Test/TestEmail`;
};

export const postApiTestTestEmail = async (
  mailRequest?: MailRequest,
  options?: RequestInit,
): Promise<postApiTestTestEmailResponseSuccess> => {
  const res = await fetch(getPostApiTestTestEmailUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(mailRequest),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: postApiTestTestEmailResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: postApiTestTestEmailResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: postApiTestTestEmailResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiTestTestEmailResponseSuccess;
};

export const getPostApiTestTestEmailMutationOptions = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTestTestEmail>>,
    TError,
    { data?: MailRequest },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTestTestEmail>>,
  TError,
  { data?: MailRequest },
  TContext
> => {
  const mutationKey = ["postApiTestTestEmail"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTestTestEmail>>,
    { data?: MailRequest }
  > = (props) => {
    const { data } = props ?? {};

    return postApiTestTestEmail(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTestTestEmailMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTestTestEmail>>
>;
export type PostApiTestTestEmailMutationBody = MailRequest | undefined;
export type PostApiTestTestEmailMutationError = globalThis.Error & {
  info?: ProblemDetails;
  status?: number;
};

export const usePostApiTestTestEmail = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTestTestEmail>>,
      TError,
      { data?: MailRequest },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTestTestEmail>>,
  TError,
  { data?: MailRequest },
  TContext
> => {
  return useMutation(
    getPostApiTestTestEmailMutationOptions(options),
    queryClient,
  );
};

export type postApiTestTestResponse200 = {
  data: void;
  status: 200;
};

export type postApiTestTestResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestTestResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestTestResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type postApiTestTestResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestTestResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestTestResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type postApiTestTestResponseSuccess = postApiTestTestResponse200 & {
  headers: Headers;
};
export type postApiTestTestResponseError = (
  | postApiTestTestResponse400TextPlain
  | postApiTestTestResponse400ApplicationJson
  | postApiTestTestResponse400TextJson
  | postApiTestTestResponse401TextPlain
  | postApiTestTestResponse401ApplicationJson
  | postApiTestTestResponse401TextJson
) & {
  headers: Headers;
};

export const getPostApiTestTestUrl = () => {
  return `/api/Test/Test`;
};

export const postApiTestTest = async (
  postApiTestTestBody?: string[],
  options?: RequestInit,
): Promise<postApiTestTestResponseSuccess> => {
  const res = await fetch(getPostApiTestTestUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(postApiTestTestBody),
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: postApiTestTestResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: postApiTestTestResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: postApiTestTestResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as postApiTestTestResponseSuccess;
};

export const getPostApiTestTestMutationOptions = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTestTest>>,
    TError,
    { data?: string[] },
    TContext
  >;
  fetch?: RequestInit;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTestTest>>,
  TError,
  { data?: string[] },
  TContext
> => {
  const mutationKey = ["postApiTestTest"];
  const { mutation: mutationOptions, fetch: fetchOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, fetch: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTestTest>>,
    { data?: string[] }
  > = (props) => {
    const { data } = props ?? {};

    return postApiTestTest(data, fetchOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTestTestMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTestTest>>
>;
export type PostApiTestTestMutationBody = string[] | undefined;
export type PostApiTestTestMutationError = globalThis.Error & {
  info?: ProblemDetails;
  status?: number;
};

export const usePostApiTestTest = <
  TError = globalThis.Error & { info?: ProblemDetails; status?: number },
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTestTest>>,
      TError,
      { data?: string[] },
      TContext
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTestTest>>,
  TError,
  { data?: string[] },
  TContext
> => {
  return useMutation(getPostApiTestTestMutationOptions(options), queryClient);
};

export type getApiTestSimulateErrorResponse200 = {
  data: void;
  status: 200;
};

export type getApiTestSimulateErrorResponse400TextPlain = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestSimulateErrorResponse400ApplicationJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestSimulateErrorResponse400TextJson = {
  data: ProblemDetails;
  status: 400;
};

export type getApiTestSimulateErrorResponse401TextPlain = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestSimulateErrorResponse401ApplicationJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestSimulateErrorResponse401TextJson = {
  data: ProblemDetails;
  status: 401;
};

export type getApiTestSimulateErrorResponse403TextPlain = {
  data: ProblemDetails;
  status: 403;
};

export type getApiTestSimulateErrorResponse403ApplicationJson = {
  data: ProblemDetails;
  status: 403;
};

export type getApiTestSimulateErrorResponse403TextJson = {
  data: ProblemDetails;
  status: 403;
};

export type getApiTestSimulateErrorResponse404TextPlain = {
  data: ProblemDetails;
  status: 404;
};

export type getApiTestSimulateErrorResponse404ApplicationJson = {
  data: ProblemDetails;
  status: 404;
};

export type getApiTestSimulateErrorResponse404TextJson = {
  data: ProblemDetails;
  status: 404;
};

export type getApiTestSimulateErrorResponse409TextPlain = {
  data: ProblemDetails;
  status: 409;
};

export type getApiTestSimulateErrorResponse409ApplicationJson = {
  data: ProblemDetails;
  status: 409;
};

export type getApiTestSimulateErrorResponse409TextJson = {
  data: ProblemDetails;
  status: 409;
};

export type getApiTestSimulateErrorResponse422TextPlain = {
  data: ProblemDetails;
  status: 422;
};

export type getApiTestSimulateErrorResponse422ApplicationJson = {
  data: ProblemDetails;
  status: 422;
};

export type getApiTestSimulateErrorResponse422TextJson = {
  data: ProblemDetails;
  status: 422;
};

export type getApiTestSimulateErrorResponse429TextPlain = {
  data: ProblemDetails;
  status: 429;
};

export type getApiTestSimulateErrorResponse429ApplicationJson = {
  data: ProblemDetails;
  status: 429;
};

export type getApiTestSimulateErrorResponse429TextJson = {
  data: ProblemDetails;
  status: 429;
};

export type getApiTestSimulateErrorResponse500 = {
  data: void;
  status: 500;
};

export type getApiTestSimulateErrorResponse502 = {
  data: void;
  status: 502;
};

export type getApiTestSimulateErrorResponse503 = {
  data: void;
  status: 503;
};

export type getApiTestSimulateErrorResponseSuccess =
  getApiTestSimulateErrorResponse200 & {
    headers: Headers;
  };
export type getApiTestSimulateErrorResponseError = (
  | getApiTestSimulateErrorResponse400TextPlain
  | getApiTestSimulateErrorResponse400ApplicationJson
  | getApiTestSimulateErrorResponse400TextJson
  | getApiTestSimulateErrorResponse401TextPlain
  | getApiTestSimulateErrorResponse401ApplicationJson
  | getApiTestSimulateErrorResponse401TextJson
  | getApiTestSimulateErrorResponse403TextPlain
  | getApiTestSimulateErrorResponse403ApplicationJson
  | getApiTestSimulateErrorResponse403TextJson
  | getApiTestSimulateErrorResponse404TextPlain
  | getApiTestSimulateErrorResponse404ApplicationJson
  | getApiTestSimulateErrorResponse404TextJson
  | getApiTestSimulateErrorResponse409TextPlain
  | getApiTestSimulateErrorResponse409ApplicationJson
  | getApiTestSimulateErrorResponse409TextJson
  | getApiTestSimulateErrorResponse422TextPlain
  | getApiTestSimulateErrorResponse422ApplicationJson
  | getApiTestSimulateErrorResponse422TextJson
  | getApiTestSimulateErrorResponse429TextPlain
  | getApiTestSimulateErrorResponse429ApplicationJson
  | getApiTestSimulateErrorResponse429TextJson
  | getApiTestSimulateErrorResponse500
  | getApiTestSimulateErrorResponse502
  | getApiTestSimulateErrorResponse503
) & {
  headers: Headers;
};

export const getGetApiTestSimulateErrorUrl = (
  params?: GetApiTestSimulateErrorParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/Test/SimulateError?${stringifiedParams}`
    : `/api/Test/SimulateError`;
};

export const getApiTestSimulateError = async (
  params?: GetApiTestSimulateErrorParams,
  options?: RequestInit,
): Promise<getApiTestSimulateErrorResponseSuccess> => {
  const res = await fetch(getGetApiTestSimulateErrorUrl(params), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const errorContentType = (
      res.headers.get("content-type") ?? ""
    ).toLowerCase();
    const err: globalThis.Error & {
      info?: getApiTestSimulateErrorResponseError["data"];
      status?: number;
    } = new globalThis.Error();
    const data: getApiTestSimulateErrorResponseError["data"] = body
      ? errorContentType.includes("json")
        ? JSON.parse(body)
        : body
      : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: getApiTestSimulateErrorResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiTestSimulateErrorResponseSuccess;
};

export const getGetApiTestSimulateErrorQueryKey = (
  params?: GetApiTestSimulateErrorParams,
) => {
  return [`/api/Test/SimulateError`, ...(params ? [params] : [])] as const;
};

export const getGetApiTestSimulateErrorQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTestSimulateError>>,
  TError = globalThis.Error & { info?: ProblemDetails | void; status?: number },
>(
  params?: GetApiTestSimulateErrorParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestSimulateError>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTestSimulateErrorQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTestSimulateError>>
  > = ({ signal }) =>
    getApiTestSimulateError(params, { signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTestSimulateError>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTestSimulateErrorQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTestSimulateError>>
>;
export type GetApiTestSimulateErrorQueryError = globalThis.Error & {
  info?: ProblemDetails | void;
  status?: number;
};

export function useGetApiTestSimulateError<
  TData = Awaited<ReturnType<typeof getApiTestSimulateError>>,
  TError = globalThis.Error & { info?: ProblemDetails | void; status?: number },
>(
  params: undefined | GetApiTestSimulateErrorParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestSimulateError>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestSimulateError>>,
          TError,
          Awaited<ReturnType<typeof getApiTestSimulateError>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestSimulateError<
  TData = Awaited<ReturnType<typeof getApiTestSimulateError>>,
  TError = globalThis.Error & { info?: ProblemDetails | void; status?: number },
>(
  params?: GetApiTestSimulateErrorParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestSimulateError>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestSimulateError>>,
          TError,
          Awaited<ReturnType<typeof getApiTestSimulateError>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestSimulateError<
  TData = Awaited<ReturnType<typeof getApiTestSimulateError>>,
  TError = globalThis.Error & { info?: ProblemDetails | void; status?: number },
>(
  params?: GetApiTestSimulateErrorParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestSimulateError>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTestSimulateError<
  TData = Awaited<ReturnType<typeof getApiTestSimulateError>>,
  TError = globalThis.Error & { info?: ProblemDetails | void; status?: number },
>(
  params?: GetApiTestSimulateErrorParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestSimulateError>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTestSimulateErrorQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}

export type getApiTestMultiplyDBEntrysResponse200 = {
  data: void;
  status: 200;
};

export type getApiTestMultiplyDBEntrysResponseSuccess =
  getApiTestMultiplyDBEntrysResponse200 & {
    headers: Headers;
  };
export const getGetApiTestMultiplyDBEntrysUrl = () => {
  return `/api/Test/MultiplyDBEntrys`;
};

export const getApiTestMultiplyDBEntrys = async (
  options?: RequestInit,
): Promise<getApiTestMultiplyDBEntrysResponseSuccess> => {
  const res = await fetch(getGetApiTestMultiplyDBEntrysUrl(), {
    ...options,
    method: "GET",
  });

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  if (!res.ok) {
    const err: globalThis.Error & { info?: any; status?: number } =
      new globalThis.Error();
    const data = body ? JSON.parse(body) : {};
    err.info = data;
    err.status = res.status;
    throw err;
  }
  const data: getApiTestMultiplyDBEntrysResponseSuccess["data"] = body
    ? JSON.parse(body)
    : undefined;
  return {
    data,
    status: res.status,
    headers: res.headers,
  } as getApiTestMultiplyDBEntrysResponseSuccess;
};

export const getGetApiTestMultiplyDBEntrysQueryKey = () => {
  return [`/api/Test/MultiplyDBEntrys`] as const;
};

export const getGetApiTestMultiplyDBEntrysQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
      TError,
      TData
    >
  >;
  fetch?: RequestInit;
}) => {
  const { query: queryOptions, fetch: fetchOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTestMultiplyDBEntrysQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>
  > = ({ signal }) => getApiTestMultiplyDBEntrys({ signal, ...fetchOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTestMultiplyDBEntrysQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>
>;
export type GetApiTestMultiplyDBEntrysQueryError = globalThis.Error & {
  info?: unknown;
  status?: number;
};

export function useGetApiTestMultiplyDBEntrys<
  TData = Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
          TError,
          Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestMultiplyDBEntrys<
  TData = Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
          TError,
          Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>
        >,
        "initialData"
      >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetApiTestMultiplyDBEntrys<
  TData = Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetApiTestMultiplyDBEntrys<
  TData = Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
  TError = globalThis.Error & { info?: unknown; status?: number },
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTestMultiplyDBEntrys>>,
        TError,
        TData
      >
    >;
    fetch?: RequestInit;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetApiTestMultiplyDBEntrysQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}
